(function () {
// Global
// Modules
const $39a084f5d3bd059b$var$shop = {
    init: ()=>{
        window.theme = window.theme || {};
        window.calcNavHeight = function() {
        // Calculates the padding on main to accommodate fixed nav
        //   if (!document.body.classList.contains('suffix-traceability-lp') || !document.body.classList.contains('suffix-foundation'))
        //   {
        //     const height = $('#shopify-section-header').outerHeight();
        //     $('main').css("padding-top", height)
        //   }
        };
        theme.config = {
            hasSessionStorage: true,
            hasLocalStorage: true,
            isTouch: "ontouchstart" in window || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints ? true : false,
            isIpad: /ipad/.test(window.navigator.userAgent.toLowerCase()) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1,
            stickyHeader: false,
            recentlyViewed: []
        };
        theme.recentlyViewed = {
            recent: {},
            productInfo: {}
        };
    }
};
var $39a084f5d3bd059b$export$2e2bcd8739ae039 = $39a084f5d3bd059b$var$shop;


const $860f3363aeb1bd10$var$global = {
    init: ()=>{
        global_accordions();
        global_modals();
        global_scrollto();
        function global_accordions() {
            $(document).on("click", ".dd-trigger", function() {
                var key = $(this).attr("key");
                if ($('.dd-container[key="' + key + '"]').hasClass("open")) $(".dd-container").removeClass("open");
                else {
                    $(".dd-container").removeClass("open");
                    $('.dd-container[key="' + key + '"]').toggleClass("open");
                }
            });
        }
        function global_scrollto() {
            $("a.scrollto").click(function() {
                $(".modal-overlay.modal-open").removeClass("modal-open");
                $("html, body").animate({
                    scrollTop: $($(this).attr("href")).offset().top
                }, 500);
                return false;
            });
        }
        function global_modals() {
            $(document).on("click", ".modal-trigger", function(e) {
                var id = $(this).attr("modal");
                $('.modal-overlay[modal="' + id + '"]').addClass("modal-open");
            });
            $(document).on("click", ".modal-close-button, .modal-overlay, .close-modal", function(e) {
                $(".modal-overlay").removeClass("modal-open");
            });
        }
        // make entire slide clickable without changing structure overmuch
        $(".our-products-slider .our-products-product").click(function() {
            window.location = $(this).data("prod-url");
            return false;
        });
        $(".our-products-slider .wc-products-product").click(function() {
            window.location = $(this).data("prod-url");
            return false;
        });
        $(document).on("click", ".page-ac-entry-trigger, .page-ac-sweepstakes-win-cta-text span", function(e) {
            $("body").addClass("ac-entry-modal-open");
        });
        $(document).on("click", ".page-ac-entry-modal-overlay, .modal-close", function(e) {
            $("body").removeClass("ac-entry-modal-open");
        });
        $(document).on("click", ".page-ac-collectors-item-product-buy-box .pdp-qty-minus", function() {
            var $current_value = parseInt($(this).parent().find(".pdp-qty-input").val());
            if ($current_value > 1) {
                var $new_value = $current_value - 1;
                $(this).parent().find(".pdp-qty-input").val($new_value);
            }
        });
        $(document).on("click", ".page-ac-collectors-item-product-buy-box .pdp-qty-plus", function() {
            var $current_value = parseInt($(this).parent().find(".pdp-qty-input").val());
            var $new_value = $current_value + 1;
            $(this).parent().find(".pdp-qty-input").val($new_value);
        });
        $(document).on("click", ".page-rm-entry-trigger, .page-sp-entry-trigger, .page-sp-sweepstakes-win-cta-text span", function(e) {
            $("body").addClass("sp-entry-modal-open");
        });
        $(document).on("click", ".page-rm-entry-modal-overlay, .page-sp-entry-modal-overlay, .modal-close", function(e) {
            $("body").removeClass("sp-entry-modal-open");
        });
        $(document).on("click", ".page-sp-buybox-product-buy-box .pdp-qty-minus", function() {
            var $current_value = parseInt($(this).parent().find(".pdp-qty-input").val());
            if ($current_value > 1) {
                var $new_value = $current_value - 1;
                $(this).parent().find(".pdp-qty-input").val($new_value);
            }
        });
        $(document).on("click", ".page-sp-buybox-product-buy-box .pdp-qty-plus", function() {
            var $current_value = parseInt($(this).parent().find(".pdp-qty-input").val());
            var $new_value = $current_value + 1;
            $(this).parent().find(".pdp-qty-input").val($new_value);
        });
        /* Override ShoppingGives */ function overrideCause() {
            const causesAll = document.querySelectorAll(`.sg-roundup-cause, .sg-addon-cause`), causeVC = "Seedlings for Sustainability";
            if (causesAll.length > 0) causesAll.forEach((cause)=>{
                if (cause.textContent != causeVC) // console.log(`Cause doesn't match: ${cause.textContent}`);
                cause.textContent = causeVC;
            });
        }
        const overrideIntervalId = setInterval(overrideCause, 500);
    }
};
var $860f3363aeb1bd10$export$2e2bcd8739ae039 = $860f3363aeb1bd10$var$global;


const $b83f6da647d0524b$var$search = {
    init: ()=>{
        if (window.location.pathname === "/search") $("#SearchInput").on("keyup", $b83f6da647d0524b$var$search.onSearch);
    },
    onSearch: async (e)=>{
        const query = e.target.value;
        const { results: results, count: count } = await $b83f6da647d0524b$var$search.getResults(query);
        const html = results.map($b83f6da647d0524b$var$search.generateItemHtml).join("");
        $(".list-view-items").empty().append(html);
        $b83f6da647d0524b$var$search.updateSearchText(query, count);
    },
    updateSearchText: (query, count)=>{
        $("h1").html(`
    <span class="visuallyhidden">Search result:</span>
    ${count} results for "${query}"
  `);
    },
    generateItemHtml: (item)=>{
        return `
    <li class="list-view-item">
      <a href="/products/${item.handle}" class="list-view-item__link">
          <img class="list-view-item__image" src="${item.featured_image}">
          <div class="list-view-item__title">${item.title}</div>
          <span class="product-price__price">${item.price}</span>
      </a>
    </li>
  `;
    },
    getResults: (query)=>$.getJSON(`/search?view=json&q=${query}`)
};
var $b83f6da647d0524b$export$2e2bcd8739ae039 = $b83f6da647d0524b$var$search;


// Desktop Dropdowns
function $84b968c03f5ed141$var$hideActiveDropdowns() {
    $(this).removeClass("active");
    $(this).children(".nav__sub-wrapper").slideUp();
}
function $84b968c03f5ed141$var$showDropdown(nav, sub_nav) {
    nav.addClass("active");
    sub_nav.stop(true, true).slideDown();
}
function $84b968c03f5ed141$var$hideDropdown(nav, sub_nav) {
    nav.removeClass("active");
    sub_nav.stop(true, true).slideUp();
}
// Mobile Dropdowns
function $84b968c03f5ed141$var$toggleActive(nav, sub_nav) {
    nav.toggleClass("active");
    sub_nav.slideToggle();
}
function $84b968c03f5ed141$var$handleHamburger() {
    $(".site-header__hamburger .hamburger").click(function() {
        $(this).toggleClass("is-active");
        $(".mobile-nav-wrapper, body").toggleClass("js-menu--is-open");
    });
}
// Nav Functions
function $84b968c03f5ed141$var$checkScroll() {
    // Changes opacity of nav to 1 on scroll
    const startY = $(".site-header").height() * 1;
    if ($(window).scrollTop() > startY) $(".site-header").addClass("scrolled");
    else $(".site-header").removeClass("scrolled");
}
const $84b968c03f5ed141$var$header = {
    init: ()=>{
        $(".js-slider.announcement-bar__wrapper.js-slider--desk").slick({
            autoplay: true,
            speed: 600,
            dots: false,
            arrows: false,
            adaptiveHeight: true
        });
        let announcement_delay = 13000;
        var announcementBarMobItems = $(".js-slider.announcement-bar__wrapper.js-slider--mob .announcement-bar__message-container");
        if (announcementBarMobItems.length > 1) $(".js-slider.announcement-bar__wrapper.js-slider--mob").slick({
            arrows: false,
            dots: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: true,
            cssEase: "linear",
            autoplay: true,
            autoplaySpeed: 0,
            adaptiveHeight: true,
            speed: announcement_delay,
            draggable: false,
            pauseOnHover: true,
            pauseOnFocus: true
        });
        $84b968c03f5ed141$var$handleHamburger();
        setTimeout(function() {
            $(".announcement-bar__wrapper").addClass("active");
        }, 100);
        $(window).on("scroll load resize", function() {
            $84b968c03f5ed141$var$checkScroll();
        });
        if (!$("body").hasClass("template-index")) $(window).on("scroll load", function() {
            calcNavHeight();
        });
        // Mobile Dropdowns
        $(".js-toggle-submenu.mobile-nav__link").each(function() {
            const nav = $(this), sub_nav = $(this).next(".mobile-nav__dropdown");
            nav.click(function() {
                $84b968c03f5ed141$var$toggleActive(nav, sub_nav);
            });
        });
        // Desktop Dropdowns
        $(".site-nav--has-dropdown").each(function() {
            const sub_nav = $(this).children(".site-nav__dropdown"), nav = $(this);
            nav.on("mouseenter touchstart", function() {
                nav.siblings(".active").each($84b968c03f5ed141$var$hideActiveDropdowns);
                $84b968c03f5ed141$var$showDropdown(nav, sub_nav);
            });
            nav.on("mouseleave touchstart", function(event) {
                $84b968c03f5ed141$var$hideDropdown(nav, sub_nav);
            });
        });
    }
};
var $84b968c03f5ed141$export$2e2bcd8739ae039 = $84b968c03f5ed141$var$header;


const $13c07fe2ad43ba53$var$footer = {
    init: ()=>{
        $(".site-footer__linklist-item a[href='https://thevitacococompany.com/']").prop("target", "_blank");
    //The Gorgias button customization, so that when customers click outside of the chat box it will automatically close the chat box.
    // $('body').on("click", function (e) {
    //     if ($(e.target).parents('#gorgias-chat-container').length == 0) {
    //         if ($('#chat-window.visible')) {
    //             GorgiasChat.close();
    //         }
    //     }
    // });
    }
};
var $13c07fe2ad43ba53$export$2e2bcd8739ae039 = $13c07fe2ad43ba53$var$footer;


const $fa4f3fae4ae078f8$var$home = {
    init: ()=>{
        if ($(".our-products-slider")[0]) $(".our-products-slider").slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            dots: false,
            arrows: false,
            adaptiveHeight: true,
            autoplay: true,
            autoplaySpeed: 0,
            speed: 16000,
            infinite: true,
            cssEase: "linear",
            waitForAnimate: false,
            pauseOnHover: false,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        autoplay: true,
                        autoplaySpeed: 0,
                        speed: 16000,
                        infinite: true,
                        cssEase: "linear"
                    }
                },
                {
                    breakpoint: 769,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        dots: false,
                        autoplay: true,
                        autoplaySpeed: 4000,
                        speed: 400,
                        infinite: true,
                        cssEase: "linear"
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: false,
                        autoplay: true,
                        autoplaySpeed: 4000,
                        speed: 400,
                        infinite: true,
                        cssEase: "linear"
                    }
                }
            ]
        });
        var ourslider = $(".our-products-slider");
        var autoplay = true;
        var restartAutoplay;
        $(document).on("click", ".our-products-slider-next", function() {
            if (autoplay == true) {
                ourslider.slick("slickSetOption", "speed", 1000, true);
                ourslider.slick("slickSetOption", "autoplay", false, true);
                autoplay = false;
                ourslider.slick("slickPrev");
                restartAutoplay = window.setTimeout(()=>{
                    ourslider.slick("slickSetOption", "speed", 16000, true);
                    ourslider.slick("slickSetOption", "autoplay", true, true);
                    autoplay = true;
                }, 5000);
            } else {
                ourslider.slick("slickNext");
                window.clearTimeout(restartAutoplay);
                restartAutoplay = window.setTimeout(()=>{
                    ourslider.slick("slickSetOption", "speed", 16000, true);
                    ourslider.slick("slickSetOption", "autoplay", true, true);
                    autoplay = true;
                }, 5000);
            }
        });
        if ($(".press-quotes")[0]) {
            $(".press-quotes").on("afterChange", function(event, slick, currentSlide, nextSlide) {
                console.log(currentSlide);
                $(".is-desk .press-quotes-page").removeClass("is-active");
                $('.is-desk .press-quotes-page[data-index="' + currentSlide + '"]').addClass("is-active");
            });
            $(".press-quotes").slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                fade: true,
                asNavFor: ".press-quotes-pager.is-mob",
                draggable: false,
                responsive: [
                    {
                        breakpoint: 769,
                        settings: {
                            draggable: true,
                            dots: false
                        }
                    }
                ]
            });
            $(".press-quotes-pager.is-mob").slick({
                // slidesToShow: 6,
                // slidesToScroll: 6,
                // asNavFor: '.press-quotes',
                // dots: false,
                // arrows: false,
                // centerMode: false,
                // focusOnSelect: true,
                slidesToShow: 4,
                slidesToScroll: 1,
                asNavFor: ".press-quotes",
                dots: false,
                centerMode: true,
                focusOnSelect: true,
                responsive: [
                    {
                        breakpoint: 769,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            arrows: false,
                            dots: true,
                            centerMode: true,
                            fade: true
                        }
                    }
                ]
            });
            let isLoading = false;
            $("body").on("mouseover", ".is-desk .press-quotes-page", function() {
                if (isLoading == false) {
                    isLoading = true;
                    $(".press-quotes").slick("slickGoTo", parseInt($(this).attr("data-index")));
                    $(".is-desk .press-quotes-page").removeClass("is-active");
                    $(this).addClass("is-active");
                    setTimeout(()=>{
                        isLoading = false;
                    }, 10);
                }
            });
        }
        if ($(".value-prop-column-props")[0]) $(".value-prop-column-props").slick({
            dots: false,
            arrows: false,
            slidesToShow: 4,
            slidesToScroll: 4,
            autoplay: false,
            responsive: [
                {
                    breakpoint: 769,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        arrows: false,
                        centerMode: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: true
                    }
                }
            ]
        });
        if ($(".hp-about-features")[0]) $(".hp-about-features").slick({
            dots: false,
            arrows: false,
            slidesToShow: 3,
            slidesToScroll: 3,
            autoplay: false,
            responsive: [
                {
                    breakpoint: 769,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                        centerMode: false,
                        dots: false,
                        adaptiveHeight: false
                    }
                }
            ]
        });
        $(document).on("click", ".hp-about-slider-next", function() {
            $(".hp-about-features").slick("slickNext");
        });
    }
};
var $fa4f3fae4ae078f8$export$2e2bcd8739ae039 = $fa4f3fae4ae078f8$var$home;


const $d813ad76ebd8a390$var$pdp = {
    init: ()=>{
        if ($(".js-pdp-gallery-slider")[0]) {
            const $arrowPrev = $(document.querySelector(`.js-pdp-gallery-slider-arrow-prev`));
            const $arrowNext = $(document.querySelector(`.js-pdp-gallery-slider-arrow-next`));
            $(".js-pdp-gallery-slider").slick({
                prevArrow: $arrowPrev,
                nextArrow: $arrowNext
            });
        }
        if ($(".pdp-gallery-slider")[0]) {
            $(".pdp-gallery-slider").slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                arrows: false,
                fade: true,
                speed: 120,
                asNavFor: ".pdp-gallery-pager",
                responsive: [
                    {
                        breakpoint: 769,
                        settings: {
                            adaptiveHeight: true,
                            dots: false,
                            asNavFor: null
                        }
                    }
                ]
            });
            $(".pdp-gallery-pager").slick({
                slidesToShow: 6,
                slidesToScroll: 1,
                asNavFor: ".pdp-gallery-slider",
                dots: false,
                arrows: false,
                centerMode: false,
                focusOnSelect: true,
                vertical: true
            });
        }
        if ($(".pdp-gallery-slider-merch")[0]) {
            if ($(".pdp-gallery-pager-merch .product-single__thumbnail-image").length > 6) {
                $(".pdp-gallery-slider-merch").slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: false,
                    arrows: false,
                    fade: true,
                    speed: 120,
                    asNavFor: ".pdp-gallery-pager-merch",
                    responsive: [
                        {
                            breakpoint: 769,
                            settings: {
                                adaptiveHeight: true
                            }
                        }
                    ]
                });
                $(".pdp-gallery-pager-merch").slick({
                    slidesToShow: 6,
                    slidesToScroll: 1,
                    asNavFor: ".pdp-gallery-slider-merch",
                    dots: false,
                    arrows: false,
                    centerMode: false,
                    focusOnSelect: true,
                    vertical: true
                });
            } else {
                $(`.pdp-gallery-pager-merch .pdp-gallery-pager-item[data-index="0"]`).addClass("is-active");
                $(".pdp-gallery-slider-merch").on("afterChange", function(slick, slider) {
                    $(".pdp-gallery-pager-merch .pdp-gallery-pager-item").removeClass("is-active");
                    $(`.pdp-gallery-pager-merch .pdp-gallery-pager-item[data-index="${slider.currentSlide}"]`).addClass("is-active");
                });
                $(".pdp-gallery-slider-merch").slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: false,
                    arrows: false,
                    fade: true,
                    speed: 120,
                    responsive: [
                        {
                            breakpoint: 769,
                            settings: {
                                adaptiveHeight: true
                            }
                        }
                    ]
                });
                $(".pdp-gallery-pager-merch .pdp-gallery-pager-item").on("click", function() {
                    $(".pdp-gallery-slider-merch").slick("slickGoTo", parseInt($(this).attr("data-index"), 10));
                });
            }
        }
        if ($(".pdp-wtd-slider")[0]) {
            $(".pdp-wtd-slider").slick({
                centerMode: true,
                slidesToShow: 4,
                slidesToScroll: 1,
                autoplay: false,
                arrows: false,
                centerPadding: "0px",
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 769,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            dots: true
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            dots: true
                        }
                    }
                ]
            });
            $(document).on("click", ".pdp-wtd-slider-next", function() {
                $(".pdp-wtd-slider").slick("slickNext");
            });
        }
        $("#productSelect").change(function(event) {
            var optionIndex = $("option:selected", this).attr("option-index");
            var optionVariant = $("option:selected", this).attr("prod-variant-id");
            var price = $("option:selected", this).attr("prod-price");
            var subscription_price = $("option:selected", this).attr("prod-subscription-price");
            var img = $("option:selected", this).attr("prod-img");
            var pack = $("option:selected", this).attr("prod-pack");
            var flav = $("option:selected", this).attr("flav-name");
            var flav_name = $("option:selected", this).attr("flav-name-handle");
            var flav_ingrediant = $("option:selected", this).attr("var-ingrediant");
            var variant_desc = $("option:selected", this).attr("prod-variant-description");
            $(".pdp-ingredients-list").hide();
            var activeVariant = ".pdp-ingredients-list." + flav_name + "-" + flav_ingrediant;
            //console.log(activeVariant);
            $(activeVariant).show();
            $(".buy-box-price").text(price);
            if ($(".js-product-rice").length > 0) $(".js-product-rice").text(price);
            $(".buy-box-subscription-price").text(subscription_price);
            // $('.pdp-product-img.feature-img').attr('src', img);
            // $('.product-single__thumbnail-image.featured').attr('src', img);
            $(".pdp-buy-box-denomination span").text(pack);
            $(".dynamic-variant-name").text(flav);
            // Update variant description
            $(".js-pdp-short-description").text(variant_desc);
            // Hide subscription and quantity from "sampler" variants
            if (flav_name === "greatest-hits-sampler-pack" || flav_name === "sampler-pack") {
                //console.log("is sampler: " + flav_name);
                $(".subscription-container").addClass("hidden");
                $(".rtx_option--sub").addClass("hidden");
                $(".pdp-qty-selector").addClass("hidden");
                $("#Quantity").attr("disabled", true).val(1);
            } else {
                //console.log("not sampler: " + flav_name);
                $(".subscription-container").removeClass("hidden");
                $(".rtx_option--sub").removeClass("hidden");
                $(".pdp-qty-selector").removeClass("hidden");
                $("#Quantity").attr("disabled", false);
            }
            refreshFilteredGalleries();
        });
        function refreshFilteredGalleries() {
            //console.log("Refreshing filtered galleries...");
            var optionIndex = $("option:selected", "#productSelect").attr("option-index");
            var optionVariant = $("option:selected", "#productSelect").attr("prod-variant-id");
            $(".pdp-gallery.is-show:not([data-gallery='global'])").removeClass("is-show");
            $(`.pdp-gallery[data-gallery="${optionVariant}"]`).addClass("is-show");
            //console.log("optionIndex: "+optionVariant);
            //console.log("optionVariant: "+optionVariant);
            var variantClass = "." + optionVariant;
            //sVariant Specific Image Filtering
            if ($(".pdp-gallery-slider").length > 0) {
                if (optionIndex == 0) {
                    $(".pdp-gallery-slider").slick("slickUnfilter");
                    $(".pdp-gallery-slider").slick("slickFilter", ".global");
                    $(".pdp-gallery-pager").slick("slickUnfilter");
                    $(".pdp-gallery-pager").slick("slickFilter", ".global");
                } else {
                    $(".pdp-gallery-slider").slick("slickUnfilter");
                    $(".pdp-gallery-slider").slick("slickFilter", variantClass);
                    $(".pdp-gallery-pager").slick("slickUnfilter");
                    $(".pdp-gallery-pager").slick("slickFilter", variantClass);
                }
            }
            // Nasty issue to track down related to using slickFilter and asNavFor
            // "This will re-align the indices on the slides, and it won’t navigate to wrong slide after filtering."
            // https://www.aakashahmed.com/jquery/slick-filter-not-working-right-on-slick-slider-fixed/
            var $slider = $(".pdp-gallery-pager, .pdp-gallery-slider");
            $slider.each(function(index, slide) {
                s_id = 0;
                //console.log(index,slide,s_id);
                $(".slick-slide:not(.slick-cloned)", slide).each(function(s_index, s_slide) {
                    $(this).attr("data-slick-index", s_id);
                    s_id = s_id + 1;
                    if (index == 0) {
                        if ($(this).hasClass("slick-current")) active_index = s_id;
                    }
                    if (index == 1) {
                        if (s_id == active_index) $(this).addClass("slick-current");
                        else $(this).removeClass("slick-current");
                    }
                });
            });
            if ($(".pdp-gallery-pager").length > 0) {
                $(".pdp-gallery-pager")[0].slick.refresh();
                $(".pdp-gallery-pager").slick("slickGoTo", 0);
                $(".pdp-gallery-slider")[0].slick.refresh();
                $(".pdp-gallery-slider").slick("slickGoTo", 0);
            }
        }
        var merch_check = $("body.suffix-merchd");
        if (!merch_check.length) refreshFilteredGalleries();
        waitForElementToDisplay(".pdp-buy-box-extra .yotpo .text-m", function() {
            let review_string = $(".pdp-buy-box-extra .yotpo .text-m").text();
            //console.log(`review_string: ${review_string}`);
            let review_string_mod = review_string.replace(" Reviews", ")"); // if "Reviews"
            review_string_mod = review_string_mod.replace(" Review", ")"); // if "Review"
            review_string_mod = review_string_mod.replace("Write a review", "0)"); // if "Write a review"
            review_string_mod = "(" + review_string_mod;
            //console.log(`review_string_mod: ${review_string_mod}`);
            $(".pdp-buy-box-extra .yotpo .text-m").text(review_string_mod);
        }, 1000, 9000);
        function waitForElementToDisplay(selector, callback, checkFrequencyInMs, timeoutInMs) {
            var startTimeInMs = Date.now();
            (function loopSearch() {
                if (document.querySelector(selector) != null) {
                    callback();
                    return;
                } else setTimeout(function() {
                    if (timeoutInMs && Date.now() - startTimeInMs > timeoutInMs) return;
                    loopSearch();
                }, checkFrequencyInMs);
            })();
        }
    }
};
var $d813ad76ebd8a390$export$2e2bcd8739ae039 = $d813ad76ebd8a390$var$pdp;


const $b234e7910ceea1c2$var$pdp_buy_box = {
    init: ()=>{
        const defaultUrlSearchParams = new URLSearchParams(window.location.search);
        let currentVariantID = parseInt(defaultUrlSearchParams.get("variant"));
        subscription_toggle();
        quantity_selector();
        select_variant_on_load();
        handleVariantSwatchKingLoad();
        $(".js-variant-radios-label").on("click", function() {
            setTimeout(function() {
                let urlSearchParams = new URLSearchParams(window.location.search);
                currentVariantID = parseInt(urlSearchParams.get("variant"));
                console.log(currentVariantID);
                handleVariantChange(currentVariantID);
            }, 500);
        });
        function handleVariantChange(variantID) {
            let currentVariant = window.productVariants.find((variant)=>variant.id === variantID);
            $("#Quantity").data("increment", currentVariant.quantity_rule.increment);
            $("#Quantity").attr("min", currentVariant.quantity_rule.min);
            $("#Quantity").attr("max", currentVariant.quantity_rule.max);
            $("#Quantity").val(currentVariant.quantity_rule.min);
        // changePriceChart(variantID, currentVariant);
        }
        function changePriceChart(variantID, variant) {
            $(".pdp-price-volume__list").empty();
            $(".pdp-price-volume__list").append(`<li class="pdp-price-volume__item">
        ${variant.quantity_rule.min}+
        <span>$${(window.defaultPrice / 100).toFixed(2)}/ea</span>
      </li>`);
            $(`.js-price-break[data-variant="${variantID}"]`).each((index, el)=>{
                if (variant.quantity_rule.min !== $(el).data("quantity")) {
                    let html = `
            <li class="pdp-price-volume__item">
              ${$(el).data("quantity")}+
              <span><del>$${(window.defaultPrice / 100).toFixed(2)}</del> - <span>$${($(el).attr("value") / 100).toFixed(2)}</span>/ea</span>
            </li>
          `;
                    $(".pdp-price-volume__list").append(html);
                }
            });
        }
        function subscription_toggle() {
            $("select#productSelect").on("change", function() {
                update_id();
            });
            $('input[name="purchaseTypeToggle"]').on("change", function() {
                update_id();
            });
            function update_id() {
                if ($("input#switch_sns").is(":checked")) {
                    var id = $("select#productSelect").find(":selected").attr("prod-variant-subscription-id");
                    if ($(".buy-box-subscription-property").length > 0) $(".buy-box-subscription-property").removeAttr("disabled");
                    if ($(".subscription-frequency-container") > 0) $(".subscription-frequency-container").removeClass("sr-hidden");
                } else {
                    var id = $("select#productSelect").find(":selected").attr("prod-variant-id");
                    var params = new URLSearchParams(window.location.search);
                    params.set("variant", id);
                    var newRelativePathQuery = window.location.pathname + "?" + params.toString();
                    history.pushState(null, "", newRelativePathQuery);
                    if ($(".buy-box-subscription-property").length > 0) $(".buy-box-subscription-property").attr("disabled", true);
                    if ($(".subscription-frequency-container").length > 0) $(".subscription-frequency-container").addClass("sr-hidden");
                    updateBasketfulLink(id);
                    hidePackSwatch();
                }
                $("#product-add-id").attr("value", id);
            }
        }
        function checkPriceBreaks(current_quantity) {
            var priceBreaks = $(`.js-price-break[data-variant="${currentVariantID}"]`);
            priceBreaks.each(function() {
                let priceBreakQuantity = parseInt($(this).data("quantity"));
                let priceBreakPrice = parseInt($(this).val());
                const $priceSelector = $(".js-product-rice");
                if (current_quantity >= priceBreakQuantity) {
                    let price = "$" + (priceBreakPrice / 100).toFixed(2);
                    $priceSelector.text(price);
                }
            });
        }
        function quantity_selector() {
            console.log("PLUS/MINUS INIT ----");
            $(document).on("click", ".pdp-qty-minus", function() {
                var purchaseQuantityMin = parseInt($(this).parent().find(".pdp-qty-input").attr("min"));
                var $current_value = parseInt($(this).parent().find(".pdp-qty-input").val());
                if ($current_value > purchaseQuantityMin) {
                    const incrementBy = parseInt($(this).parent().find(".pdp-qty-input").data("increment"));
                    var $new_value = $current_value - incrementBy;
                    $(this).parent().find(".pdp-qty-input").val($new_value);
                    $(document).find(".js-pdp-qty-selector-warning").hide();
                    checkPriceBreaks($new_value);
                } else if ($current_value === purchaseQuantityMin) {
                    let message = `*Min quantity of ${purchaseQuantityMin} reached.`;
                    $(document).find(".js-pdp-qty-selector-warning").text(message);
                    $(document).find(".js-pdp-qty-selector-warning").show();
                }
            });
            $(document).on("click", ".pdp-qty-plus", function() {
                var purchaseQuantityMax = parseInt($(this).parent().find(".pdp-qty-input").attr("max"));
                var $current_value = parseInt($(this).parent().find(".pdp-qty-input").val());
                if (!purchaseQuantityMax || $current_value < purchaseQuantityMax) {
                    const incrementBy = parseInt($(this).parent().find(".pdp-qty-input").data("increment"));
                    var $new_value = $current_value + incrementBy;
                    $(this).parent().find(".pdp-qty-input").val($new_value);
                    $(document).find(".js-pdp-qty-selector-warning").hide();
                    checkPriceBreaks($new_value);
                } else if ($current_value === purchaseQuantityMax) {
                    let message = `*Max quantity of ${purchaseQuantityMax} reached.`;
                    $(document).find(".js-pdp-qty-selector-warning").text(message);
                    $(document).find(".js-pdp-qty-selector-warning").show();
                }
            });
        }
        // On load, make sure to select the correct variant id in the select if on a subscription pdp
        function select_variant_on_load() {
            $(function() {
                var params = new URLSearchParams(window.location.search);
                var variantSelectElement = $("select#productSelect");
                if (variantSelectElement && params.has("variant")) variantSelectElement.val(params.get("variant")).change();
            });
        }
        // Updates the Basketful barcode when variant ID changes.
        function updateBasketfulLink(id) {
            const productData = window.productData;
            if ((!id || !productData) && productData[id]) return;
            const el = document.querySelector(".js-basketful-link");
            if (el !== null) el.setAttribute("data-basketful-product-locator-upc", productData[id]);
        }
        // Hides Pack swatch if 'variant.metafields.pdp_variant.hide_variant === true'
        function hidePackSwatch() {
            if (window.theme.pdp != undefined) {
                const { hideVariantPack: hideVariantPack } = window.theme.pdp;
                document.querySelectorAll(".variant-radios__input");
                if (document.querySelector('[swatch-option="option1"].swatch-selected') != null) {
                    console.log(`got here - hideVariantPack: ${hideVariantPack}`);
                    const activeFlavor = document.querySelector('[swatch-option="option1"].swatch-selected').dataset.value;
                    console.log(`got here - activeFlavor: ${hideVariantPack}`);
                    if (!hideVariantPack || !activeFlavor || hideVariantPack[activeFlavor].length === 0) return;
                    document.querySelectorAll('[swatch-option="option2"].swatch-button').forEach((el)=>{
                        if (hideVariantPack[activeFlavor].includes(el.dataset.value)) el.parentNode.style.display = "none";
                    });
                }
            }
        }
        function handleVariantSwatchKingLoad() {
            const intervalId = setInterval(()=>{
                if (document.querySelector("variant-swatch-king")) {
                    clearInterval(intervalId);
                    hidePackSwatch();
                }
            }, 100);
        }
    }
};
var $b234e7910ceea1c2$export$2e2bcd8739ae039 = $b234e7910ceea1c2$var$pdp_buy_box;


const $ef49bc2968620044$var$page_our_story = {
    init: ()=>{
        if ($(".os-slider")[0]) $(".os-slider").slick({
            accessibility: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            arrows: false,
            vertical: true,
            verticalSwiping: true,
            dots: true,
            responsive: [
                {
                    breakpoint: 769,
                    settings: {
                        vertical: false,
                        verticalSwiping: false
                    }
                }
            ]
        });
    }
};
var $ef49bc2968620044$export$2e2bcd8739ae039 = $ef49bc2968620044$var$page_our_story;


const $c9ba80c1cd826078$var$page_rewards = {
    init: ()=>{
        $(window).on("load", function() {
            update_buttons();
        });
        function update_buttons() {
            console.log("one");
            var svg_arrow = '<svg xmlns="http://www.w3.org/2000/svg" class="icon-arrow-right" width="34" viewBox="0 0 33.3 22.16"><g id="right-arrow"><path d="M22.22 0L20.4 1.83l8 8H0v2.58h28.36l-8 8 1.82 1.83L33.3 11.08z" fill="#0047ba" /></g></svg>';
            $(svg_arrow).appendTo("button.yotpo-button-style");
            $("button.yotpo-button-style").attr("style", "opacity: 1");
        }
    }
};
var $c9ba80c1cd826078$export$2e2bcd8739ae039 = $c9ba80c1cd826078$var$page_rewards;


const $e8b8aafa70436427$var$page_wcdlp = {
    init: ()=>{
        $(document).ready(function() {
            $(".staff-slider-wrapper").slick({
                infinite: true,
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: true,
                responsive: [
                    {
                        breakpoint: 769,
                        settings: {
                            slidesToShow: 1.05,
                            slidesToScroll: 1,
                            dots: true,
                            arrows: false
                        }
                    }
                ]
            });
        });
        var clicks = 0;
        $(document).on("click", ".staff-slider-next", function() {
            var slides = $(".staff-slide.slick-slide").length - 1;
            if (clicks < slides) {
                $(".staff-slider-wrapper").slick("slickNext");
                clicks += 1;
            } else if (clicks >= slides) {
                $(".staff-slider-wrapper").slick("slickPrev");
                clicks = 0;
            }
        });
        // open modal
        $(".notify-btn").on("click", function() {
            $("#notify-overlay").removeClass("notify-hide");
            $("body").addClass("no-scroll");
        });
        // click "x", close modal
        $("#notify-close").on("click", function() {
            $("#notify-overlay").addClass("notify-hide");
            $("body").removeClass("no-scroll");
        });
        // click outside, close modal
        $("#notify-overlay").click(function(event) {
            if (!$(event.target).closest(".modal-outer").length && !$(event.target).is(".modal-outer")) {
                $("#notify-overlay").addClass("notify-hide");
                $("body").removeClass("no-scroll");
            }
        });
        // upon submit
        $(".klaviyo-form-SAanpE button").on("click", function() {
            $(".email-eyebrow").addClass("notify-hide");
            console.log("got here");
        });
        // show video
        $("#watch-now-btn").on("click", function() {
            $("#youtube-video-embed").removeClass("video-hide");
            $("#video-thumb").addClass("thumb-content-hide");
            $("#watch-now-btn-mobile").addClass("thumb-content-hide");
        });
        $("#watch-now-btn-mobile").on("click", function() {
            $("#youtube-video-embed").removeClass("video-hide");
            $("#watch-now-btn-mobile").addClass("thumb-content-hide");
            $("#video-thumb").addClass("thumb-content-hide");
        });
    }
};
var $e8b8aafa70436427$export$2e2bcd8739ae039 = $e8b8aafa70436427$var$page_wcdlp;


const $591a3d5b84cfbab7$var$accountLogin = {
    init: ()=>{
        const SHOW_PASSWORD_CLASS = "show-password";
        const refs = {
            containerEl: document.querySelector(".js-account-password-container"),
            buttonEl: document.querySelector(".js-account-password-button"),
            inputEl: document.querySelector(".js-account-password-input")
        };
        // Only proceed if all required DOM elements exist.
        if (Object.values(refs).some((el)=>!el)) return;
        const actions = {
            togglePasswordVisibility: ()=>{
                console.log("togglePasswordVisibility");
                if (refs.containerEl.classList.contains(SHOW_PASSWORD_CLASS)) {
                    refs.containerEl.classList.remove(SHOW_PASSWORD_CLASS);
                    refs.inputEl.type = "password";
                } else {
                    refs.containerEl.classList.add(SHOW_PASSWORD_CLASS);
                    refs.inputEl.type = "text";
                }
            }
        };
        refs.buttonEl.addEventListener("click", actions.togglePasswordVisibility);
    }
};
var $591a3d5b84cfbab7$export$2e2bcd8739ae039 = $591a3d5b84cfbab7$var$accountLogin;


const $fabcb6bca031c168$var$hangover_subscription = {
    init: ()=>{
        const DEFAULTS = {
            LINK_TEXT: "SHOP NOW",
            LINK_URL: "/pages/hangover-subscription-quiz?view=hangover-subscription-quiz"
        };
        const refs = {
            quizEl: document.querySelector("#shopify-section-hangover-subscription-hangover-buy-box"),
            buttonEls: document.querySelectorAll("a.btn-with-arrow")
        };
        refs.buttonEls.forEach((el)=>{
            const textEl = el.querySelector("span");
            if (textEl) textEl.innerText = DEFAULTS.LINK_TEXT;
            el.href = DEFAULTS.LINK_URL;
        });
        if (refs.quizEl) refs.quizEl.style.display = "none";
    }
};
var $fabcb6bca031c168$export$2e2bcd8739ae039 = $fabcb6bca031c168$var$hangover_subscription;


const $fbe1969b43572293$var$mega_menu = {
    init: ()=>{
        $("body").on("click", ".js-mega-menu-slider-next", function(e) {
            e.preventDefault();
            const parent = $(e.target).parents(".js-mega-menu-slider");
            const els = parent.find(".mega-menu__block");
            let doScroll = true;
            let indexEl = 0;
            els.each(function() {
                if ($(this).offset().left - parent.offset().left > 0 && doScroll == true) doScroll = false;
                if (doScroll == true) indexEl += 1;
            });
            parent.animate({
                scrollLeft: indexEl * 197
            }, "slow");
        });
        $(".js-mega-menu-slider").on("scroll", function() {
            var newScrollLeft = $(this).scrollLeft(), width = $(this).outerWidth(), scrollWidth = $(this).get(0).scrollWidth;
            if (scrollWidth - newScrollLeft == width) $(this).addClass("is-end");
            else $(this).removeClass("is-end");
        });
        function checkArrow() {
            $(".js-mega-menu-slider").each(function() {
                var newScrollLeft = $(this).scrollLeft(), width = $(this).outerWidth(), scrollWidth = $(this).get(0).scrollWidth;
                if (Math.round(scrollWidth - newScrollLeft) == Math.round(width)) $(this).addClass("is-end");
                else $(this).removeClass("is-end");
            });
        }
        checkArrow();
        $(window).on("resize", function() {
            checkArrow();
        });
    }
};
var $fbe1969b43572293$export$2e2bcd8739ae039 = $fbe1969b43572293$var$mega_menu;


const $bdd457042d4c0801$var$hblp_buybox = {
    init: ()=>{
        if ($(".hblp-buybox__slider")[0]) $(".hblp-buybox__slider").slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: false,
            // centerMode: true,
            adaptiveHeight: true,
            autoplay: true,
            autoplaySpeed: 5000,
            speed: 500,
            infinite: true,
            cssEase: "linear",
            waitForAnimate: false,
            pauseOnHover: false
        });
        // Handle UI
        $(".hblp-buybox__product-btn").on("click", function() {
            $(".hblp-buybox__product-btn").attr("data-selected", false);
            $(this).attr("data-selected", true);
            updateATCPrice();
        });
        $(".hblp-buybox__gift-btn").on("click", function() {
            $(".hblp-buybox__gift-btn").attr("data-selected", false);
            $(this).attr("data-selected", true);
            updateATCPrice();
        });
        // Update ATC Price
        function updateATCPrice() {
            let prodPrice = $('.hblp-buybox__product-btn[data-selected="true"]').data("price");
            let prodQty = $('.hblp-buybox__product-btn[data-selected="true"]').data("quantity");
            let giftPrice = $('.hblp-buybox__gift-btn[data-selected="true"]').data("price");
            let giftQty = $('.hblp-buybox__gift-btn[data-selected="true"]').data("quantity");
            let total = ((prodPrice * prodQty + giftPrice * giftQty) / 100).toFixed(2);
            $("#addToCart [data-price]").text(total);
        }
        updateATCPrice();
        $("#addToCart").on("click", function() {
            var hs_id = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
            let prodVariantId = $('.hblp-buybox__product-btn[data-selected="true"]').data("variant-id");
            let prodQty = $('.hblp-buybox__product-btn[data-selected="true"]').data("quantity");
            let merchVariantId = $('.hblp-buybox__gift-btn[data-selected="true"]').data("variant-id");
            let merchQty = $('.hblp-buybox__gift-btn[data-selected="true"]').data("quantity");
            add_product();
            function add_product() {
                var data = {
                    "quantity": prodQty,
                    "id": prodVariantId,
                    "properties[_hs_sub_product]": true,
                    "properties[_hslp_qualifying]": true,
                    "properties[_hs_id]": hs_id
                };
                $.ajax({
                    type: "POST",
                    url: "/cart/add.js",
                    dataType: "json",
                    data: data,
                    success: function(res) {
                        add_merch();
                    },
                    error: function() {
                        console.log("Error adding HBLP product to cart");
                    }
                });
            }
            function add_merch() {
                var data = {
                    "quantity": merchQty,
                    "id": merchVariantId,
                    "properties[_hslp_merch]": true,
                    "properties[_hs_id]": hs_id
                };
                $.ajax({
                    type: "POST",
                    url: "/cart/add.js",
                    dataType: "json",
                    data: data,
                    success: function(res) {
                        console.log("Successfully added to Cart");
                        // window.SLIDECART_UPDATE();
                        // window.SLIDECART_OPEN();
                        window.LSG_OPEN_CART();
                    },
                    error: function() {
                        console.log("Error adding HBLP gift to cart");
                    }
                });
            }
        });
    }
};
var $bdd457042d4c0801$export$2e2bcd8739ae039 = $bdd457042d4c0801$var$hblp_buybox;


class $842959f5ffebbab2$var$VariantRadios extends HTMLElement {
    onVariantClick() {
        this.querySelectorAll(".js-variant-radios-label").forEach((el)=>{
            el.addEventListener("click", ()=>{
                if (this.querySelector(`#${el.getAttribute("for")}`).checked) this.classList.toggle("is-open");
                else this.classList.remove("is-open");
                this.focus();
            });
        });
        document.querySelector("body").addEventListener("click", (e)=>{
            if (e.target.closest(".variant-radios") == null || e.target.classList.contains("variant-radios")) this.classList.remove("is-open");
        });
    }
    onVariantChange(e) {
        this.updateOptions();
        this.updateMasterId();
        this.updateMasterIdMetafileds();
        this.updateVariantStatuses();
        this.updateAddToCart();
        this.hideNotification();
        if (!this.currentVariant) ;
        else {
            this.updateVariantInput();
            // this.updateFlavorTitle();
            this.updateURL();
            this.updateOptionsTitle();
            this.updateGallery();
        }
    }
    updateGallery() {
        var slider = document.querySelectorAll(".pdp-gallery-slider-merch");
        slider.forEach((el)=>{
            var _this_currentVariant_featured_image;
            const slide = el.querySelector(`.pdp-gallery-slide[data-id="${(_this_currentVariant_featured_image = this.currentVariant.featured_image) === null || _this_currentVariant_featured_image === void 0 ? void 0 : _this_currentVariant_featured_image.id}"]`);
            if (slide != null) $(slider).slick("slickGoTo", parseInt(slide.getAttribute("data-index"), 10));
        });
    }
    updateAddToCart() {
        const productForm = this.from;
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        if (!addButton) return;
        if (!this.currentVariant) addButton.classList.add("is-disabled");
        else if (this.currentVariant.available) addButton.classList.remove("is-disabled");
        else addButton.classList.add("is-disabled");
    }
    hideNotification() {
        const productForm = this.from;
        if (!productForm) return;
        const notification = productForm.querySelector(".slidecart-form-error");
        if (notification != null) notification.remove();
    }
    updateAddToCart() {
        const productForm = this.from;
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');
        if (!addButton) return;
        if (!this.currentVariant) {
            addButtonText.textContent = theme.productStrings.unavailable;
            addButton.setAttribute("disabled", "disabled");
        } else if (this.currentVariant.available) {
            addButtonText.textContent = theme.productStrings.addToCart;
            addButton.removeAttribute("disabled");
        } else {
            if (this.currentVariantMetafields.coming_soon == "true") addButtonText.textContent = theme.productStrings.comingSoon;
            else addButtonText.textContent = theme.productStrings.soldOut;
            addButton.setAttribute("disabled", "disabled");
        }
    }
    updateOptionsTitle() {
        this.optionsTitle.forEach((el)=>{
            el.textContent = this.currentVariant.options[parseInt(el.getAttribute("data-index"), 10)];
        });
    }
    updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant)=>{
            return !variant.options.map((option, index)=>{
                return this.options[index] === option;
            }).includes(false);
        });
    }
    updateMasterIdMetafileds() {
        if (this.currentVariant) this.currentVariantMetafields = this.getVariantMetafieldsData().find((variant)=>{
            return variant.id == this.currentVariant.id;
        });
    }
    updateURL() {
        const body = document.querySelector("body");
        if (!this.currentVariant || this.dataset.updateUrl === "false") return;
        if (!body.classList.contains("template-collection") && !body.classList.contains("template-search")) window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
    updateVariantInput() {
        const productForms = document.querySelectorAll(`form`);
        const body = document.querySelector("body");
        productForms.forEach((productForm)=>{
            const select = productForm.querySelector("#productSelect");
            if (select != null) {
                select.value = this.currentVariant.id;
                if (!body.classList.contains("template-collection") && !body.classList.contains("template-search")) select.dispatchEvent(new Event("change", {
                    bubbles: true
                }));
            } else {
                const input = productForm.querySelector('[name="id"]');
                if (input != null) {
                    input.value = this.currentVariant.id;
                    if (!body.classList.contains("template-collection") && !body.classList.contains("template-search")) input.dispatchEvent(new Event("change", {
                        bubbles: true
                    }));
                }
            }
        });
    }
    updateVariantStatuses() {
        const selectedOptionOneVariants = this.variantData.filter((variant)=>this.querySelector(":checked").value === variant.option1);
        const inputWrappers = [
            ...this.querySelectorAll(".product-form__input")
        ];
        inputWrappers.forEach((option, index)=>{
            if (index === 0) return;
            const optionInputs = [
                ...option.querySelectorAll('input[type="radio"], option')
            ];
            const previousOptionSelected = inputWrappers[index - 1].querySelector(":checked").value;
            const availableOptionInputsValue = selectedOptionOneVariants.filter((variant)=>variant[`option${index}`] === previousOptionSelected).map((variantOption)=>variantOption[`option${index + 1}`]);
            this.setInputAvailability(optionInputs, availableOptionInputsValue);
            const available2OptionInputsValue = selectedOptionOneVariants.filter((variant)=>variant.available && variant[`option${index}`] === previousOptionSelected).map((variantOption)=>variantOption[`option${index + 1}`]);
            this.setInputAvailability2(optionInputs, available2OptionInputsValue);
        });
    }
    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"].js-variants').textContent);
        return this.variantData;
    }
    getVariantMetafieldsData() {
        this.variantMetafieldsData = this.variantMetafieldsData || JSON.parse(this.querySelector('[type="application/json"].js-variants-metafields').textContent);
        return this.variantMetafieldsData;
    }
    setInputAvailability2(listOfOptions, listOfAvailableOptions) {
        listOfOptions.forEach((input)=>{
            if (listOfAvailableOptions.includes(input.getAttribute("value"))) input.classList.remove("is-unavailable");
            else input.classList.add("is-unavailable");
        });
    }
    setInputAvailability(listOfOptions, listOfAvailableOptions) {
        listOfOptions.forEach((input)=>{
            if (listOfAvailableOptions.includes(input.getAttribute("value"))) input.classList.remove("disabled");
            else input.classList.add("disabled");
        });
        const inputWrappers = [
            ...this.querySelectorAll(".product-form__input")
        ];
        inputWrappers.forEach((option, index)=>{
            if (index === 0) return;
            const optionInputs = [
                ...option.querySelectorAll('input[type="radio"]:not(.disabled):checked')
            ];
            if (optionInputs.length == 0) {
                const optionInputsEnable = [
                    ...option.querySelectorAll('input[type="radio"]:not(.disabled)')
                ];
                if (optionInputsEnable.length > 0) {
                    optionInputsEnable[0].checked = true;
                    optionInputsEnable[0].dispatchEvent(new Event("change", {
                        bubbles: true
                    }));
                }
            }
        });
    }
    updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll("fieldset"));
        this.options = fieldsets.map((fieldset)=>{
            return Array.from(fieldset.querySelectorAll("input")).find((radio)=>radio.checked).value;
        });
    }
    constructor(){
        super();
        this.optionsTitle = this.querySelectorAll(".js-variant-radios-ttl");
        this.addEventListener("change", this.onVariantChange);
        this.onVariantClick();
        this.from = this.closest("form");
    }
}
customElements.define("variant-radios", $842959f5ffebbab2$var$VariantRadios);


class $22c5b1ae548773ae$var$LSGCounter extends HTMLElement {
    connectedCallback() {
        if (this.animationEnabled && this.animationTarget && this.elCounter) this.handleScroll();
    }
    handleScroll() {
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting && !this.hasAnimated) {
                    this.hasAnimated = true;
                    this.animateCounter(0, this.animationTarget, this.animationDuration);
                }
            });
        }, {
            threshold: 0.5
        });
        observer.observe(this);
    }
    formatNumber(number) {
        return number.toLocaleString();
    }
    animateCounter(start, end, duration) {
        const startTime = performance.now();
        const updateCounter = (currentTime)=>{
            const elapsedTime = currentTime - startTime;
            const progress = Math.min(elapsedTime / duration, 1);
            const currentValue = Math.floor(progress * (end - start) + start);
            this.elCounter.textContent = this.formatNumber(currentValue);
            if (progress < 1) requestAnimationFrame(updateCounter);
        };
        requestAnimationFrame(updateCounter);
    }
    constructor(){
        super();
        this.animationEnabled = this.dataset.animationEnabled === "true";
        this.animationTarget = +this.dataset.animationTarget;
        this.animationDuration = +this.dataset.animationDuration || 5000;
        this.elCounter = this.querySelector(".lsg-counter__value");
        this.hasAnimated = false;
    }
}
const $22c5b1ae548773ae$var$customElementName = "lsg-counter";
if (!customElements.get($22c5b1ae548773ae$var$customElementName)) window.customElements.define($22c5b1ae548773ae$var$customElementName, $22c5b1ae548773ae$var$LSGCounter);


class $0b504fb43044d7b1$var$LSGFaq extends HTMLElement {
    connectedCallback() {
        this.handleFaqQuestionsClick();
    }
    handleFaqQuestionsClick() {
        if (!this.selectors.faqs.length) return;
        this.selectors.faqs.forEach((faq)=>{
            const question = faq.querySelector(`.${this.classes.faqQuestion}`);
            const answer = faq.querySelector(`.${this.classes.faqAnswer}`);
            if (!question || !answer) return;
            question.addEventListener("click", ()=>{
                answer.style.maxHeight = faq.classList.contains(this.classes.active) ? 0 : `${answer.scrollHeight + 20}px`;
                faq.classList.toggle(this.classes.active);
            });
        });
    }
    constructor(){
        super();
        this.classes = {
            active: "active",
            faq: "js-lsg-faq-item",
            faqQuestion: "js-lsg-faq-item-question",
            faqAnswer: "js-lsg-faq-item-answer"
        };
        this.selectors = {
            faqs: this.querySelectorAll(`.${this.classes.faq}`)
        };
    }
}
const $0b504fb43044d7b1$var$customElementName = "lsg-faq";
if (!customElements.get($0b504fb43044d7b1$var$customElementName)) window.customElements.define($0b504fb43044d7b1$var$customElementName, $0b504fb43044d7b1$var$LSGFaq);



class $89bb14a391f35b87$var$RobloxProducts extends HTMLElement {
    constructor(){
        super();
        this.slider = $(this.querySelector(".js-roblox-products"));
        console.log(this.slider);
        if (this.slider.length > 0) this.slider.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            dots: false,
            arrows: true,
            adaptiveHeight: false,
            prevArrow: '<button type="button" class="slick-prev"><svg width="90" height="91" viewBox="0 0 90 91" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d_3_8322)"><circle cx="25" cy="25" r="25" transform="matrix(-1 0 0 1 70 20.3433)" fill="#0047BB"/><path fill-rule="evenodd" clip-rule="evenodd" d="M31.1496 46.1926C31.3118 45.9496 36.3628 41.0974 41.8129 37.3433C42.8167 38.0516 43.5168 39.0729 43.8848 40.0361C41.2706 41.6672 38.354 43.1309 35.7691 44.8498C44.5024 44.1193 48.106 44.3237 57.9909 44.8585L58.5218 44.901L58.7593 45.4258C58.9643 45.8787 59.0406 46.3703 58.9795 46.8481C58.9281 47.255 58.7807 47.6387 58.5418 47.9872L58.227 48.4463L57.7078 48.3921C50.4813 47.7031 45.8014 47.496 36.1398 47.6892C38.967 49.1492 41.7359 50.2607 44.6729 51.4707C44.3608 52.4536 43.9117 53.5782 42.95 54.3433C38.9142 52.7097 32.5183 48.9981 31.1423 46.8757C30.9942 46.6476 30.9121 46.4315 31.1496 46.1926Z" fill="#F2E9DB"/></g><defs><filter id="filter0_d_3_8322" x="0" y="0.343262" width="90" height="90" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset/><feGaussianBlur stdDeviation="10"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3_8322"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3_8322" result="shape"/></filter></defs></svg></button>',
            nextArrow: '<button type="button" class="slick-next"><svg width="90" height="91" viewBox="0 0 90 91" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d_3_8319)"><circle cx="45" cy="45.3433" r="25" fill="#0047BB"/><path fill-rule="evenodd" clip-rule="evenodd" d="M58.8504 46.1926C58.6882 45.9496 53.6372 41.0974 48.1871 37.3433C47.1833 38.0516 46.4832 39.0729 46.1152 40.0361C48.7294 41.6672 51.646 43.1309 54.2309 44.8498C45.4976 44.1193 41.894 44.3237 32.0091 44.8585L31.4782 44.901L31.2407 45.4258C31.0357 45.8787 30.9594 46.3703 31.0205 46.8481C31.0719 47.255 31.2193 47.6387 31.4582 47.9872L31.773 48.4463L32.2922 48.3921C39.5187 47.7031 44.1986 47.496 53.8602 47.6892C51.033 49.1492 48.2641 50.2607 45.3271 51.4707C45.6392 52.4536 46.0883 53.5782 47.05 54.3433C51.0858 52.7097 57.4817 48.9981 58.8577 46.8757C59.0058 46.6476 59.0879 46.4315 58.8504 46.1926" fill="#F2E9DB"/></g><defs><filter id="filter0_d_3_8319" x="0" y="0.343262" width="90" height="90" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset/><feGaussianBlur stdDeviation="10"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3_8319"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3_8319" result="shape"/></filter></defs></svg></button>',
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });
    }
}
var $89bb14a391f35b87$export$2e2bcd8739ae039 = $89bb14a391f35b87$var$RobloxProducts;


const $4b080af75b914be2$var$sfs_5050 = {
    init: ()=>{
        if ($(".shopify-section .sfs-5050")[0]) $(".shopify-section .sfs-5050").each(function() {
            let section_id = $(this).data("section-id");
            let parent = `.sfs-5050[data-section-id="${section_id}"]`;
            function randomRotate($photoEl) {
                let randMin = -10, randMax = 10.00, degrees = (Math.random() * (randMax - randMin) + randMin).toFixed(4), dist = degrees * 2;
                $photoEl.css("transform", `rotate(${degrees}deg) translateY(${dist}px) translateX(${dist}px) scale(0.9)`);
            }
            $(`${parent} .sfs-5050__images.stack .photo-stack__photo`).each(function() {
                randomRotate($(this));
            });
            $(`${parent} .sfs-5050__images.stack .photo-stack__photo`).on("click", function() {
                $(this).css({
                    "opacity": 0,
                    "transform": "translateY(50px) scale(0.9)"
                });
                setTimeout(()=>{
                    $(this).insertBefore($(".photo-stack__photo")[0]);
                }, 250);
                setTimeout(()=>{
                    $(this).css("opacity", 1);
                    randomRotate($(this));
                }, 1000);
            });
        });
    }
};
var $4b080af75b914be2$export$2e2bcd8739ae039 = $4b080af75b914be2$var$sfs_5050;


const $b88d8452506c9393$var$sfs_fixed = {
    init: ()=>{
        if ($(".shopify-section .sfs-fixed")[0]) $(".shopify-section .sfs-fixed").each(function() {
            let section_id = $(this).data("section-id");
            let parent = `.sfs-fixed[data-section-id="${section_id}"]`;
            function randomRotate($photoEl) {
                let randMin = -10, randMax = 10.00, degrees = (Math.random() * (randMax - randMin) + randMin).toFixed(4), dist = degrees * 2;
                $photoEl.css("transform", `rotate(${degrees}deg) translateY(${dist}px) translateX(${dist}px)`);
            }
            $(`${parent} .sfs-fixed__images .photo-stack__photo`).each(function() {
                randomRotate($(this));
            });
        });
    }
};
var $b88d8452506c9393$export$2e2bcd8739ae039 = $b88d8452506c9393$var$sfs_fixed;


const $df45f0987d6f0645$var$benefitsAnimation = {
    init: ()=>{
        function startAnimation(element, endValue, hasPercentage) {
            let currentValue = 0;
            const step = Math.ceil(endValue / 100);
            const interval = setInterval(()=>{
                if (currentValue + step >= endValue) {
                    currentValue = endValue;
                    clearInterval(interval);
                } else currentValue += step;
                element.textContent = currentValue + (hasPercentage ? "%" : "");
            }, 20);
        }
        function handleIntersection(entries, observer) {
            entries.forEach((entry)=>{
                if (entry.isIntersecting) {
                    const element = entry.target;
                    const textContent = element.textContent.trim();
                    const endValue = textContent.includes("%") ? parseInt(textContent.replace(/\D/g, ""), 10) : parseFloat(textContent);
                    startAnimation(element, endValue, textContent.includes("%"));
                    observer.unobserve(element);
                }
            });
        }
        function observeIntersection() {
            const percentageElements = document.querySelectorAll(".lsg-benefits__info-percentige");
            const observer = new IntersectionObserver(handleIntersection, {
                threshold: 0.5
            });
            percentageElements.forEach((element)=>{
                observer.observe(element);
            });
        }
        // document.addEventListener("DOMContentLoaded", observeIntersection);
        observeIntersection();
    }
};
var $df45f0987d6f0645$export$2e2bcd8739ae039 = $df45f0987d6f0645$var$benefitsAnimation;


const $28a65792f86eb58e$var$communitySlider = {
    init: ()=>{
        // Play with this value to change the speed
        let tickerSpeed = 1;
        let flickity = null;
        let isPaused = false;
        const slideshowEl = document.querySelector(".lsg-js-slideshow");
        //   Functions
        const update = ()=>{
            if (isPaused) return;
            if (flickity.slides) {
                flickity.x = (flickity.x - tickerSpeed) % flickity.slideableWidth;
                flickity.selectedIndex = flickity.dragEndRestingSelect();
                flickity.updateSelectedSlide();
                flickity.settle(flickity.x);
            }
            window.requestAnimationFrame(update);
        };
        const pause = ()=>{
            isPaused = true;
        };
        const play = ()=>{
            if (isPaused) {
                isPaused = false;
                window.requestAnimationFrame(update);
            }
        };
        //   Create Flickity
        flickity = new Flickity(slideshowEl, {
            autoPlay: false,
            prevNextButtons: true,
            pageDots: false,
            draggable: true,
            wrapAround: true,
            selectedAttraction: 0.015,
            friction: 0.25
        });
        flickity.x = 0;
        //   Add Event Listeners
        slideshowEl.addEventListener("mouseenter", pause, false);
        slideshowEl.addEventListener("focusin", pause, false);
        slideshowEl.addEventListener("mouseleave", play, false);
        slideshowEl.addEventListener("focusout", play, false);
        flickity.on("dragStart", ()=>{
            isPaused = true;
        });
        //   Start Ticker
        update();
    }
};
var $28a65792f86eb58e$export$2e2bcd8739ae039 = $28a65792f86eb58e$var$communitySlider;


const $e58b8765f7866f3c$var$ourValuesSlider = {
    init: ()=>{
        if (window.innerWidth < 768) $(document).ready(function() {
            var $slider = $(".lsg-our-values__slides");
            var $progressBar = $(".lsg-our-values__progress");
            var $progressBarLabel = $(".lsg-our-values__progress-label");
            $slider.on("init reInit afterChange", function(event, slick) {
                var currentSlide = slick.slickCurrentSlide() + 1;
                var initialPercentage = currentSlide / slick.slideCount * 100;
                var calc = initialPercentage + (currentSlide - 1 || 0) / slick.slideCount * (100 - initialPercentage);
                calc = calc.toFixed(2);
                var backgroundSize = window.innerWidth > 1023 ? "100% " + calc + "%" : calc + "% 100%";
                $progressBar.css("background-size", backgroundSize).attr("aria-valuenow", calc);
                $progressBarLabel.text(calc + "% completed");
            });
            $slider.slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: false,
                vertical: true,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            vertical: false
                        }
                    }
                ]
            });
        });
    }
};
var $e58b8765f7866f3c$export$2e2bcd8739ae039 = $e58b8765f7866f3c$var$ourValuesSlider;


const $594a965aa5e33f8e$var$stickyCta = {
    init: ()=>{
        var classActive = "active";
        var element = document.querySelector(".lsg-sticky-cta");
        var isInViewport = function(elem) {
            var rect = elem.getBoundingClientRect();
            return rect.bottom >= 0 && rect.right >= 0 && rect.top <= (window.innerHeight || document.documentElement.clientHeight) && rect.left <= (window.innerWidth || document.documentElement.clientWidth);
        };
        var debounce = function(func, delay) {
            var timeout;
            return function() {
                var context = this;
                var args = arguments;
                clearTimeout(timeout);
                timeout = setTimeout(function() {
                    func.apply(context, args);
                }, delay);
            };
        };
        var handleScroll = function() {
            var targetSections = [
                document.querySelector("#lsg-hero-careers"),
                document.querySelector("#shopify-section-footer")
            ];
            var isAnySectionInView = targetSections.some(function(section) {
                return section && isInViewport(section);
            });
            if (isAnySectionInView) element.classList.remove(classActive);
            else element.classList.add(classActive);
        };
        var debouncedScroll = debounce(handleScroll, 50); // Adjust the debounce delay as needed
        window.addEventListener("scroll", debouncedScroll);
    }
};
var $594a965aa5e33f8e$export$2e2bcd8739ae039 = $594a965aa5e33f8e$var$stickyCta;


const $c3958bd31d4ac42c$var$testimonialsSlider = {
    init: ()=>{
        if (window.innerWidth <= 767) $(".lsg-testimonials__slides").slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            centerMode: true,
            centerPadding: "37px"
        });
    }
};
var $c3958bd31d4ac42c$export$2e2bcd8739ae039 = $c3958bd31d4ac42c$var$testimonialsSlider;


const $1eb0adad1e3be584$var$sfs_progress = {
    init: ()=>{
        if ($(".shopify-section .sfs-progress")[0]) {
            $(".shopify-section .sfs-progress").each(function() {
                let section_id = $(this).data("section-id");
                let parent = `.sfs-progress[data-section-id="${section_id}"]`;
                const barParentEl = document.querySelector(`${parent} [sfs-progress-bar-wrapper]`), dotParentEl = document.querySelector(`${parent} [sfs-progress-dot-wrapper]`), barEl = document.querySelector(`${parent} [sfs-progress-bar-actual]`), labelTopEl = document.querySelector(`${parent} [sfs-progress-bar-wrapper] .label-top`), labelBottomEl = document.querySelector(`${parent} [sfs-progress-bar-wrapper] .label-bottom`), labelTopNumEl = document.querySelector(`${parent} [sfs-progress-donated]`), labelTopNumFormat = parseInt(labelTopNumEl.textContent).toLocaleString("en", {
                    useGrouping: true
                }), donated = barParentEl.getAttribute("data-donated"), //   donated               = 10000000,
                target = barParentEl.getAttribute("data-target"), percent = Math.max(donated / target * 100, 20), awayNumEl = document.querySelector(`${parent} [sfs-progress-away]`), awayNumFormat = parseInt(awayNumEl.textContent).toLocaleString("en", {
                    useGrouping: true
                });
                labelTopNumEl.textContent = labelTopNumFormat;
                awayNumEl.textContent = awayNumFormat;
                function animate() {
                    setTimeout(()=>{
                        dotParentEl.style.left = `${percent}%`;
                        barEl.style.width = `${percent}%`;
                    }, 500);
                    setTimeout(()=>{
                        labelTopEl.style.opacity = `1`;
                        labelBottomEl.style.opacity = `1`;
                    }, 2500);
                }
                const observer = new IntersectionObserver((entries, observer)=>{
                    if (!entries[0].isIntersecting) return;
                    animate();
                }, {
                    threshold: 1
                });
                observer.observe(barParentEl);
                dotParentEl.addEventListener(`transitionend`, ()=>{
                    const labelTopEl = dotParentEl.querySelector(`.label-top`), labelBotEl = dotParentEl.querySelector(`.label-bottom`), labelTargetEl = barParentEl.querySelector(`${parent} .sfs-progress__label-target`);
                    checkValidPosition(labelTopEl);
                    checkValidPosition(labelBotEl);
                    checkOverlap(labelTopEl, labelTargetEl);
                });
            });
            function checkOverlap(frontEl, rearEl) {
                const fB = frontEl.getBoundingClientRect(), rB = rearEl.getBoundingClientRect();
                let fx2 = fB.x + fB.width;
                if (fx2 > rB.x) rearEl.style.opacity = 0;
            }
            function checkValidPosition(element) {
                const bounds = element.getBoundingClientRect();
                if (bounds.x < 0) {
                    element.style.position = "relative";
                    element.style.left = "50px";
                } else if (bounds.x + bounds.width > window.screen.width) {
                    element.style.position = "relative";
                    let diff = bounds.x + bounds.width - window.screen.width;
                    element.style.right = `${diff + 20}px`;
                }
            }
        }
    }
};
var $1eb0adad1e3be584$export$2e2bcd8739ae039 = $1eb0adad1e3be584$var$sfs_progress;


const $35f8fb112b56de8b$var$sfs_stats = {
    init: ()=>{
        if ($(".shopify-section .sfs-stats")[0]) {
            $(".shopify-section .sfs-stats").each(function() {
                let section_id = $(this).data("section-id");
                let parent = `.sfs-stats[data-section-id="${section_id}"]`;
                const offsetStats = document.querySelectorAll(`${parent} [carbon-offset-stat]`);
                fetch("https://merchant.ecocart.io/merchant/lsg-dev02.myshopify.com").then((e)=>{
                    return e.json();
                }).then((data)=>{
                    const MULTIPLY_KG_TO_LB = 2.20462;
                    const statVal = data.stats.merchant.all_time.carbon_offset * MULTIPLY_KG_TO_LB;
                    offsetStats.forEach((offsetStat)=>{
                        offsetStat.setAttribute(`data-stat`, statVal / 1000000);
                    });
                    initCounters(parent);
                });
            });
            function roundToTwo(num) {
                return +(Math.round(num + "e+2") + "e-2");
            }
            function initCounters(parent) {
                const countersEl = document.querySelector(`${parent} [sfs-stats-wrapper]`), counters = document.querySelectorAll(`${parent} [sfs-stats-number]`), time = 5, rate = 10; // updates per second
                function animateCounters(counter) {
                    const animate = ()=>{
                        const value = +counter.getAttribute("data-stat");
                        const data = +counter.getAttribute("data-progress");
                        let result;
                        const increment = value / time / rate;
                        if (data < value) {
                            if (counter.getAttribute("sfs-round") === "true") result = roundToTwo(data + increment);
                            else result = Math.ceil(data + increment);
                            setTimeout(animate, 1000 / rate);
                        } else if (counter.getAttribute("sfs-round") === "true") result = roundToTwo(value);
                        else result = value;
                        counter.setAttribute("data-progress", result);
                        counter.innerText = result.toLocaleString();
                    };
                    animate();
                }
                counters.forEach((counter)=>{
                    const observer = new IntersectionObserver((entries, observer)=>{
                        if (!entries[0].isIntersecting) return;
                        animateCounters(counter);
                    }, {
                        threshold: 1
                    });
                    observer.observe(counter);
                });
            }
        }
    }
};
var $35f8fb112b56de8b$export$2e2bcd8739ae039 = $35f8fb112b56de8b$var$sfs_stats;


const $ee62d4dfdd7d940f$var$lsg_slidecart = {
    init: ()=>{
        /**
         * TODO:
         *   - Completely remove dependency on JQuery
         *   - Possibly separate some processes to be called independently
         *     -> Currently, render process is one long chain for every cart update.
         *        Could save on unnecessary API calls in certain cases.
         *        For instance, upsells are pulled afresh every time the cart is
         *        re-rendered. Doesn't make sense for merely increasing quantity
         *        of existing products w/ none added/removed. Also causes a significant
         *        layout jump when upsells disappear/reappear.
         *   - Improve/refine Theme Editor support
         *   - General restructure/consolidation/clean-up
         */ // Elements
        const openBtn = document.querySelector("[lsg-slidecart-open]"), closeBtn = document.querySelectorAll("[lsg-slidecart-close]"), upsellWrapper = document.querySelector(".lsg-slidecart__upsell-wrapper");
        upsellModule = document.querySelector("[lsg-slidecart-upsell-list]"), upsellSlider = document.querySelector("[lsg-slidecart-upsell-slider]"), productFormEls = document.querySelectorAll(`[lsg-cart-form]`);
        //   productForm       = document.getElementById('AddToCartForm');
        // Main Slidecart opening process
        function slideCartOpen() {
            renderCart();
        }
        // Open the Slidecart accessible externally in the window
        window.LSG_OPEN_CART = function LSG_OPEN_CART() {
            slideCartOpen();
        };
        // Ask the Slidecart to re-render itself
        window.LSG_CART_UPDATE = function LSG_CART_UPDATE() {
            renderCart();
        };
        // Open slidecart if #cart present in window location
        // Used with redirect from /cart to /#cart to obfuscate cart template
        if (window.location.href.indexOf("#cart") > -1) slideCartOpen();
        // Close the Slidecart
        function slideCartClose() {
            $("body").css("overflow-y", "scroll");
            $(`.lsg-slidecart`).removeClass("active");
            $(`[lsg-slidecart-overlay]`).removeClass("active");
        }
        // Event listeners
        openBtn.addEventListener("click", (e)=>{
            e.preventDefault();
            slideCartOpen();
        });
        closeBtn.forEach((el)=>{
            el.addEventListener("click", (e)=>{
                slideCartClose();
            });
        });
        // Take over processing of ATC from standard Shopify product forms
        productFormEls.forEach((productForm)=>{
            productForm.addEventListener("submit", (e)=>{
                e.preventDefault();
                console.log(`[LSG] Processing Form.`);
                let data = new FormData(e.target);
                $.ajax({
                    type: "POST",
                    url: window.Shopify.routes.root + "cart/add.js",
                    data: data,
                    processData: false,
                    contentType: false,
                    success: function(response) {
                        console.log(`[LSG] Opening Cart.`);
                        slideCartOpen();
                    },
                    error: function(errResponse) {
                        console.log(errResponse);
                    }
                });
            });
        });
        // Reset Slidecart
        function clearCartDrawer() {
            $(`[lsg-slidecart-product-wrapper]`).html("");
            upsellWrapper.style.display = "none";
        }
        // Cart rendering processes
        function renderCart() {
            $.ajax({
                type: "GET",
                url: "/cart.js",
                dataType: "json",
                success: function(cart) {
                    console.log(`[LSG] Rendering cart.`);
                    clearCartDrawer();
                    const productListEl = document.querySelector(`[lsg-slidecart-product-wrapper]`);
                    const loyalty = productListEl.getAttribute(`lsg-slidecart-loyalty`);
                    const productsBFCM23 = [
                        7019104567484,
                        7021125468348,
                        7736798019772,
                        7520208748732,
                        7741630218428,
                        7021125402812
                    ];
                    let caseQty = 0;
                    cart.items.forEach((item)=>{
                        if (productsBFCM23.includes(item.product_id)) caseQty += item.quantity;
                    });
                    $(`[shipping-bar-percent]`).css("max-width", "0%");
                    const freeShipText = $(`[slidecart-shipping-bar]`).attr("free-shipping-success-text");
                    const freeShipping = parseInt($(`[slidecart-shipping-bar]`).attr("free-shipping-threshold"));
                    var amountToShipping = (freeShipping - parseFloat(cart.items_subtotal_price / 100).toFixed(2)).toFixed(2);
                    if (amountToShipping <= 0) {
                        $(`[shipping-bar-percent]`).css("max-width", "100%");
                        $(`[shipping-bar-text]`).text(freeShipText);
                    } else if (parseInt(amountToShipping) == freeShipping) {
                        $("[lsg-slidecart-product-wrapper]").html("Your cart is empty");
                        $(`[shipping-bar-text]`).text(`You're $${amountToShipping} away from free shipping!`);
                    } else if (cart.items_subtotal_price === 0) $("[lsg-slidecart-product-wrapper]").html("Your cart is empty");
                    else {
                        var maxWidth = parseFloat(cart.items_subtotal_price / 100).toFixed(1) / parseInt(freeShipping) * 100;
                        $(`[shipping-bar-percent]`).css("max-width", maxWidth + "%");
                        $(`[shipping-bar-text]`).text(`You're $${amountToShipping} away from free shipping!`);
                    }
                    const cartSubtotal = `$${parseFloat(cart.items_subtotal_price / 100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1").toString()}`;
                    $(`[lsg-slidecart-subtotal-price]`).text(cartSubtotal);
                    cart.items.forEach(function(item, index) {
                        let loyaltyMessage = "", bfcm_active = false;
                        if (bfcm_active) {
                            if (productsBFCM23.includes(item.product_id) && loyalty === "true" && caseQty == 2) loyaltyMessage = `
                                    <div style="width: 100%; text-align: right; font-size: 14px; padding-top: 5px;">
                                    Loyalty Discount 2 Cases 25% Off
                                    </div>
                                    `;
                            else if (productsBFCM23.includes(item.product_id) && loyalty === "true" && caseQty >= 3) loyaltyMessage = `
                                    <div style="width: 100%; text-align: right; font-size: 14px; padding-top: 5px;">
                                    Loyalty Discount 3+ Cases 30% Off
                                    </div>
                                    `;
                            else if (productsBFCM23.includes(item.product_id) && loyalty !== "true" && caseQty == 2) loyaltyMessage = `
                                    <div style="width: 100%; text-align: right; font-size: 14px; padding-top: 5px;">
                                    BFCM Discount 2 Cases 20% Off
                                    </div>
                                    `;
                            else if (productsBFCM23.includes(item.product_id) && loyalty !== "true" && caseQty >= 3) loyaltyMessage = `
                                    <div style="width: 100%; text-align: right; font-size: 14px; padding-top: 5px;">
                                    BFCM Discount 3+ Cases 25% Off
                                    </div>
                                    `;
                        }
                        const productTitle = `<h3>${item.product_title}</h3>`;
                        const productId = item.id;
                        const productImage = `<img src="${item.image + "&width=200"}" >`;
                        let options = "";
                        item.variant_options.forEach(function(option, index) {
                            if (typeof option == "undefined") return;
                            if (option == "Default Title") return;
                            options = `${options}<p>${option}</p>`;
                        });
                        let sellingPlan = "";
                        if (JSON.stringify(item.selling_plan_allocation) != null) sellingPlan = `<p>${item.selling_plan_allocation.selling_plan.name}</p>`;
                        let priceDisplay;
                        if (item.price * item.quantity !== item.line_price) {
                            //console.log(`item.price: ${item.price}, item.line_price: ${item.line_price}`);
                            let regPrice = `$${parseFloat(item.price * item.quantity / 100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1").toString()}`;
                            let salePrice = `$${parseFloat(item.line_price / 100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1").toString()}`;
                            priceDisplay = `<span style="text-decoration: line-through;">${regPrice}</span> ${salePrice}`;
                        } else priceDisplay = `$${parseFloat(item.line_price / 100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1").toString()}`;
                        const productPrice = `<p>${priceDisplay}</p>`;
                        const productQuantity = item.quantity;
                        const itemKey = item.key;
                        const concatProductInfo = `
                            <li
                                class="lsg-slidecart__item"
                                data-slidecart-item="${productId}"
                                data-line="${Number(index + 1)}"
                                role="group"
                                aria-label="Product"
                            >
                                <div class="lsg-slidecart__item-wrapper">
                                    <div class="lsg-slidecart__item-image-wrapper">
                                        ${productImage}
                                    </div>
                                    <div class="lsg-slidecart__item-details-wrapper">

                                        <div class="lsg-slidecart__item-description-wrapper">
                                            ${productTitle}
                                            ${options}
                                            ${sellingPlan}
                                        </div>

                                        <div class="lsg-slidecart__item-controls">
                                            <button
                                                type="button"
                                                aria-label="Remove Item"
                                                lsg-slidecart-remove-item
                                                data-remove-key="${itemKey}"
                                            >
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10"><g id="close"><path d="M9.677 8.118a1.102 1.102 0 11-1.559 1.56L5 6.558 1.882 9.677a1.102 1.102 0 11-1.56-1.559L3.442 5 .323 1.882A1.102 1.102 0 111.882.322L5 3.442 8.118.323a1.102 1.102 0 111.56 1.559L6.558 5l3.118 3.118z" fill="currentColor"/></g></svg>
                                            </button>
                                        </div>

                                        <div class="lsg-slidecart__item-qty-wrapper">
                                            <div class="lsg-slidecart__item-qty-controls">
                                                <button
                                                    type="button"
                                                    aria-label="Decrease Quantity"
                                                    class="qty-button js-minus-button"
                                                    data-minus
                                                    data-qty-button
                                                    data-key="${itemKey}"
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="minus"><rect x="5" y="46" width="90" height="8" fill="currentColor"/></g></svg>
                                                </button>
                                                <input
                                                    class="js-cart-qty-input"
                                                    type="number"
                                                    pattern="[0-9]*"
                                                    data-input-key="${itemKey}"
                                                    value="${productQuantity}"
                                                />
                                                <button
                                                    type="button"
                                                    aria-label="Increase Quantity"
                                                    class="qty-button js-plus-button"
                                                    data-plus
                                                    data-qty-button
                                                    data-key="${itemKey}"
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="plus"><polygon points="95 46 54 46 54 5 46 5 46 46 5 46 5 54 46 54 46 95 54 95 54 54 95 54 95 46" fill="currentColor"/></g></svg>
                                                </button>
                                            </div>
                                        </div>

                                        <div class="lsg-slidecart__item-price">
                                            ${productPrice}
                                        </div>

                                    </div>
                                </div>
                                ${loyaltyMessage}
                            </li>
                        `;
                        $(`[lsg-slidecart-product-wrapper]`).html($(`[lsg-slidecart-product-wrapper]`).html() + concatProductInfo);
                    });
                    $(`[js-cart-qty-input]`).change(function() {
                        var newQty = parseInt($(this).attr("value"));
                        var key = $(this).attr("data-input-key");
                        var data = {
                            "id": key,
                            "quantity": newQty
                        };
                        $(this).attr("value", newQty);
                        $.ajax({
                            type: "POST",
                            url: "/cart/change.js",
                            data: data,
                            dataType: "json",
                            success: function() {
                                renderCart();
                            }
                        });
                    });
                    $(`[data-qty-button]`).click(function() {
                        var key = $(this).attr("data-key");
                        var currentQty = parseInt($(`[data-input-key="${key}"]`).attr("value"));
                        var newQty;
                        var data;
                        if ($(this).hasClass("js-plus-button")) {
                            newQty = currentQty + 1;
                            data = {
                                "id": key,
                                "quantity": newQty
                            };
                        } else {
                            newQty = currentQty - 1;
                            data = {
                                "id": key,
                                "quantity": newQty
                            };
                        }
                        $(`[data-input-key="${key}"]`).attr("value", newQty);
                        $.ajax({
                            type: "POST",
                            url: "/cart/change.js",
                            data: data,
                            dataType: "json",
                            success: function() {
                                renderCart();
                            }
                        });
                    });
                    $(`[lsg-slidecart-remove-item]`).on("click", function() {
                        var key = $(this).attr("data-remove-key");
                        var data = {
                            "id": key,
                            "quantity": 0
                        };
                        $.ajax({
                            type: "POST",
                            url: "/cart/change.js",
                            data: data,
                            dataType: "json",
                            success: function() {
                                renderCart();
                            }
                        });
                    });
                    console.log(`[LSG] Cart:`, cart);
                    const countBadgeEl = document.querySelector(`[lsg-cart-count]`);
                    countBadgeEl.textContent = cart.item_count;
                    // Open cart
                    $(`.lsg-slidecart`).addClass("active");
                    $(`[lsg-slidecart-overlay]`).addClass("active");
                    $("body").css("overflow-y", "hidden");
                    if (upsellModule) renderUpsells(cart);
                }
            });
        }
        function renderUpsells(cart) {
            $(`[lsg-slidecart-upsell-list]`).html("");
            let baseURL = `${window.Shopify.routes.root}recommendations/products.json`;
            let limit = 3; // Per product
            let intent = upsellModule.getAttribute("data-recc-type"); // Optional, 'related' (default) or 'complementary'
            let tasksTotal = cart.items.length;
            let tasksDone = 0;
            const upsellItems = [];
            // Hit the recommendations API for each product in cart to compile a list
            cart.items.forEach(function(item, index) {
                let callURL = `${baseURL}?product_id=${item.product_id}&limit=${limit}&intent=${intent}`;
                $.ajax({
                    type: "GET",
                    url: callURL,
                    dataType: "json",
                    success: function(data) {
                        data.products.forEach(function(product, index) {
                            if (!product.available) return;
                            if (!product.variants[0].available) return;
                            let productData = {
                                "product_id": product.id,
                                "product_title": product.title,
                                "product_img": product.featured_image,
                                "variant_id": product.variants[0].id,
                                "price": product.variants[0].price
                            };
                            upsellItems.push(productData);
                        });
                        tasksDone += 1;
                        if (tasksDone == tasksTotal) buildUpsells(upsellItems);
                    }
                });
            });
        }
        function buildUpsells(data) {
            // Uniquify upsell products
            const items = [
                ...new Map(data.map((v)=>[
                        v.product_title,
                        v
                    ])).values()
            ];
            if (items.length > 1) upsellWrapper.style.display = "block";
            else upsellWrapper.style.display = "none";
            items.forEach(function(item, index) {
                let listItem = document.createElement("li");
                listItem.classList.add("lsg-slidecart__upsell-list-item");
                listItem.innerHTML = `
                    <div class="lsg-slidecart__upsell-inner-wrapper">
                        <div class="lsg-slidecart__upsell-details-wrapper">
                            <div class="lsg-slidecart__upsell-image-wrapper">
                                <img src="${item.product_img + "&width=200"}" alt="">
                            </div>
                            <div>
                                <h3 class="lsg-slidecart__upsell-title">${item.product_title}</h3>
                                <div class="lsg-slidecart__upsell-price">$${(item.price / 100).toFixed(2)}</div>
                            </div>
                        </div>
                        <button
                            class="lsg-slidecart__upsell-button"
                            lsg-slidecart-upsell-button
                            data-variant-id="${item.variant_id}"
                        >
                            + Add
                        </button>
                    </div>
                `;
                upsellModule.append(listItem);
            });
            const upsellBtns = document.querySelectorAll("[lsg-slidecart-upsell-button]");
            upsellBtns.forEach((el)=>{
                el.addEventListener("click", (e)=>{
                    const productData = {
                        items: [
                            {
                                id: parseInt(e.target.getAttribute("data-variant-id")),
                                quantity: 1
                            }
                        ]
                    };
                    fetch(window.Shopify.routes.root + "cart/add.js", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify(productData)
                    }).then((response)=>response.json()).then((data)=>{
                        if (data.status) console.error(`${data.message}: Status ${data.status} - ${data.description}`);
                        else renderCart();
                    }).catch((error)=>{
                        console.error("Error:", error);
                    });
                });
            });
        }
        // Simple slider implementation
        if (upsellSlider) {
            const slidesContainer = upsellSlider.querySelector(".lsg-slidecart__upsell-list"), prevBtn = upsellSlider.querySelector("#slide-arrow-prev"), nextBtn = upsellSlider.querySelector("#slide-arrow-next");
            nextBtn.addEventListener("click", ()=>{
                let slide = upsellSlider.querySelector(".lsg-slidecart__upsell-list-item");
                const slideWidth = slide.clientWidth;
                slidesContainer.scrollLeft += slideWidth;
            });
            prevBtn.addEventListener("click", ()=>{
                let slide = upsellSlider.querySelector(".lsg-slidecart__upsell-list-item");
                const slideWidth = slide.clientWidth;
                slidesContainer.scrollLeft -= slideWidth;
            });
        }
        /**
         * Theme Editor Support
         */ const parent = `.lsg-slidecart`;
        // Section loaded in Theme Editor
        document.addEventListener("shopify:section:select", function(event) {
            const $parent = $(event.target);
            let check = $parent.find(`${parent}`);
            if (check.length > 0) slideCartOpen();
        });
        document.addEventListener("shopify:section:deselect", function(event) {
            const $parent = $(event.target);
            let check = $parent.find(`${parent}`);
            if (check.length > 0) slideCartClose();
        });
        // Block selected in Theme Editor
        document.addEventListener("shopify:block:select", function(event) {
            const $block = $(event.target);
            const $parent = $block.parents(`${parent}`);
            $parent.length;
        });
        // Block deselected in Theme Editor
        document.addEventListener("shopify:block:deselect", function(event) {
            const $block = $(event.target);
            const $parent = $block.parents(`${parent}`);
            $parent.length;
        });
    }
};
var $ee62d4dfdd7d940f$export$2e2bcd8739ae039 = $ee62d4dfdd7d940f$var$lsg_slidecart;


class $64fb530211c04ea0$var$MultimediaBlock extends HTMLElement {
    checkLoadMore(html) {
        const newLoadMore = html.querySelector(this.selectors.loadMore);
        if (newLoadMore != null) {
            this.loadMore.classList.add("is-visible");
            this.loadMore.setAttribute("data-next", newLoadMore.getAttribute("data-next"));
        } else this.loadMore.classList.remove("is-visible");
    }
    initLoadMore() {
        this.loadMore.addEventListener("click", ()=>{
            this.getHtml(this.loadMore.getAttribute("data-next"));
        });
    }
    getHtml(url) {
        fetch(url).then((response)=>{
            return response.json();
        }).then((state)=>{
            const html = new DOMParser().parseFromString(state[this.dataSection], "text/html");
            html.querySelectorAll(this.selectors.article).forEach((el)=>{
                this.grid.append(el);
            });
            setTimeout(()=>{
                this.querySelectorAll(this.selectors.article).forEach((el, index)=>{
                    el.classList.remove("is-hidden");
                });
            }, 10);
            this.checkLoadMore(html);
            this.initPlay();
        }).catch((error)=>{
            this.style.display = "none";
        });
    }
    initPlay() {
        this.playBtn = this.querySelectorAll(this.selectors.playBtn);
        this.playBtn.forEach((el)=>{
            el.addEventListener("click", ()=>{
                const parent = el.closest(".js-article");
                if (parent != null) {
                    var _parent_querySelector;
                    parent.classList.add("is-playing");
                    (_parent_querySelector = parent.querySelector("video")) === null || _parent_querySelector === void 0 ? void 0 : _parent_querySelector.play();
                }
            });
        });
    }
    init() {
        this.getHtml(this.url);
        this.initLoadMore();
        this.initPlay();
    }
    constructor(){
        super();
        this.selectors = {
            grid: ".js-grid",
            article: ".js-article",
            loadMore: ".js-load-more",
            playBtn: ".js-play"
        };
        this.grid = this.querySelector(this.selectors.grid);
        this.loadMore = this.querySelector(this.selectors.loadMore);
        this.url = this.getAttribute("data-tag");
        this.dataSection = this.getAttribute("data-section");
        this.init();
    }
}
var $64fb530211c04ea0$export$2e2bcd8739ae039 = $64fb530211c04ea0$var$MultimediaBlock;


class $27664f6f0419e892$var$MultimediaSearch extends HTMLElement {
    initLoadMore() {
        this.loadMore = this.querySelector(this.selectors.loadMore);
        if (this.loadMore != null) this.loadMore.addEventListener("click", ()=>{
            this.getHtmlLoadMore(`${this.url}&page=${this.loadMore.getAttribute("data-next")}`);
        });
    }
    checkLoadMore(html) {
        const newLoadMore = html.querySelector(this.selectors.loadMore);
        if (newLoadMore != null) {
            this.loadMore.classList.add("is-visible");
            this.loadMore.setAttribute("data-next", newLoadMore.getAttribute("data-next"));
        } else this.loadMore.classList.remove("is-visible");
    }
    getHtml(url) {
        this.wrap.classList.add("is-loading");
        this.url = url;
        fetch(url).then((response)=>{
            return response.json();
        }).then((state)=>{
            var _document_querySelector;
            const html = new DOMParser().parseFromString(state[this.dataSection], "text/html");
            this.wrap.innerHTML = html.querySelector(this.selectors.wrap).innerHTML;
            this.wrap.classList.remove("is-loading");
            (_document_querySelector = document.querySelector(".multimedia__nav-item.is-active")) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.classList.remove("is-active");
            this.grid = document.querySelector(this.selectors.grid);
            setTimeout(()=>{
                this.querySelectorAll(this.selectors.article).forEach((el, index)=>{
                    el.classList.remove("is-hidden");
                });
            }, 10);
            this.initLoadMore();
        }).catch((error)=>{
            this.wrap.classList.remove("is-loading");
        });
    }
    getHtmlLoadMore(url) {
        fetch(url).then((response)=>{
            return response.json();
        }).then((state)=>{
            const html = new DOMParser().parseFromString(state[this.dataSection], "text/html");
            html.querySelectorAll(this.selectors.article).forEach((el)=>{
                this.grid.append(el);
            });
            setTimeout(()=>{
                this.querySelectorAll(this.selectors.article).forEach((el, index)=>{
                    el.classList.remove("is-hidden");
                });
            }, 10);
            this.checkLoadMore(html);
        }).catch((error)=>{
            this.style.display = "none";
        });
    }
    init() {
        this.form.addEventListener("submit", (e)=>{
            e.preventDefault();
            let formData = new FormData(this.form);
            let search = new URLSearchParams(formData);
            let queryString = search.toString();
            this.getHtml(`${this.form.getAttribute("action")}?${queryString}`);
        });
    }
    constructor(){
        super();
        this.selectors = {
            form: ".js-multimedia-search-form",
            wrap: ".js-multimedia-search-wrap",
            grid: ".js-grid",
            article: ".js-article",
            loadMore: ".js-load-more"
        };
        this.form = document.querySelector(this.selectors.form);
        this.wrap = this.querySelector(this.selectors.wrap);
        this.dataSection = this.getAttribute("data-section");
        this.url = "";
        this.init();
    }
}
var $27664f6f0419e892$export$2e2bcd8739ae039 = $27664f6f0419e892$var$MultimediaSearch;


if (!customElements.get("variant-selects")) {
    class VariantSelect extends HTMLElement {
        onVariantChange(e) {
            this.updateOptions();
            this.updateMasterId();
            this.updateMasterIdMetafileds();
            this.updateVariantStatuses();
            this.updateAddToCart();
            this.hideNotification();
            if (!this.currentVariant) ;
            else {
                this.updateVariantInput();
                if (this.currentVariantMetafields.featured_images != null) {
                    let img = "";
                    this.currentVariantMetafields.featured_images.forEach((el, index)=>{
                        img += `<img src="${el.src}" alt="" srcset="${el.src} 750w" width="${el.width}" height="${el.height}"  class="hp-product-card__img sr-media__img ${this.currentVariantMetafields.featured_images.length > 1 ? index == 0 ? "  hp-product-card__img--first" : "hp-product-card__img--hover" : ""}" sizes="100vw">`;
                    });
                    const parent = this.closest(".hp-product-card");
                    if (parent != null) {
                        const media = parent.querySelector(".hp-product-card__media:not(.hp-product-card__media--no-change)");
                        if (media != null) media.innerHTML = img;
                    }
                } else if (this.currentVariant.featured_image) {
                    const img = `<img src="${this.currentVariant.featured_image.src}&amp;width=750" alt="" srcset="${this.currentVariant.featured_image.src}&amp;width=375 375w, ${this.currentVariant.featured_image.src}&amp;width=550 550w, ${this.currentVariant.featured_image.src}&amp;width=750 750w" width="${this.currentVariant.featured_image.width}" height="${this.currentVariant.featured_image.height}"  class="hp-product-card__img sr-media__img" sizes="100vw">`;
                    const parent = this.closest(".hp-product-card");
                    if (parent != null) {
                        const media = parent.querySelector(".hp-product-card__media:not(.hp-product-card__media--no-change)");
                        if (media != null) media.innerHTML = img;
                    }
                }
            }
        }
        // Not sure why this function is here twice?
        /*
        updateAddToCart() {
            const productForm = this.from;
            if (!productForm) return;
            const addButton = productForm.querySelector('[name="add"]');
            if (!addButton) return;
            if (!this.currentVariant) {
                addButton.classList.add('is-disabled');
            } else {
                if (this.currentVariant.available) {
                    addButton.classList.remove('is-disabled');
                } else {
                    addButton.classList.add('is-disabled');
                }
            }
        }
        */ hideNotification() {
            const productForm = this.from;
            if (!productForm) return;
            const notification = productForm.querySelector(".slidecart-form-error");
            if (notification != null) notification.remove();
        }
        updateAddToCart() {
            const productForm = this.from;
            if (!productForm) return;
            const addButton = productForm.querySelector('[name="add"]');
            const addButtonText = productForm.querySelector('[name="add"] > span');
            if (!addButton) return;
            if (!this.currentVariant) {
                addButtonText.textContent = theme.productStrings.unavailable;
                addButton.setAttribute("disabled", "disabled");
            } else if (this.currentVariant.available) {
                addButtonText.textContent = theme.productStrings.addToCart;
                addButton.removeAttribute("disabled");
            } else {
                if (this.currentVariantMetafields.coming_soon == "true") addButtonText.textContent = theme.productStrings.comingSoon;
                else addButtonText.textContent = theme.productStrings.soldOut;
                addButton.setAttribute("disabled", "disabled");
            }
        }
        updateMasterId() {
            this.currentVariant = this.getVariantData().find((variant)=>{
                return !variant.options.map((option, index)=>{
                    return this.options[index] === option;
                }).includes(false);
            });
        }
        updateMasterIdMetafileds() {
            if (this.currentVariant) this.currentVariantMetafields = this.getVariantMetafieldsData().find((variant)=>{
                return variant.id == this.currentVariant.id;
            });
        }
        updateVariantInput() {
            const productForm = this.from;
            const input = productForm.querySelector('[name="id"]');
            if (input != null) {
                input.value = this.currentVariant.id;
                let event = new Event(`change`);
                input.dispatchEvent(event);
            }
        }
        updateVariantStatuses() {
            const selectedOptionOneVariants = this.variantData.filter((variant)=>this.querySelector(":checked").value === variant.option1);
            const inputWrappers = [
                ...this.querySelectorAll(".js-variant-select-input")
            ];
            inputWrappers.forEach((option, index)=>{
                if (index === 0) return;
                const optionInputs = [
                    ...option.querySelectorAll("option")
                ];
                const previousOptionSelected = inputWrappers[index - 1].querySelector(":checked").value;
                const availableOptionInputsValue = selectedOptionOneVariants.filter((variant)=>variant.available && variant[`option${index}`] === previousOptionSelected).map((variantOption)=>variantOption[`option${index + 1}`]);
            // this.setInputAvailability2(optionInputs, availableOptionInputsValue)
            });
        }
        getVariantData() {
            this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"].js-variants').textContent);
            return this.variantData;
        }
        getVariantMetafieldsData() {
            this.variantMetafieldsData = this.variantMetafieldsData || JSON.parse(this.querySelector('[type="application/json"].js-variants-metafields').textContent);
            return this.variantMetafieldsData;
        }
        setInputAvailability2(listOfOptions, listOfAvailableOptions) {
            listOfOptions.forEach((input)=>{
                if (listOfAvailableOptions.includes(input.getAttribute("value"))) input.classList.remove("is-unavailable");
                else input.classList.add("is-unavailable");
            });
        }
        setInputAvailability(listOfOptions, listOfAvailableOptions) {
            listOfOptions.forEach((input)=>{
                if (listOfAvailableOptions.includes(input.getAttribute("value"))) input.classList.remove("disabled");
                else input.classList.add("disabled");
            });
            const inputWrappers = [
                ...this.querySelectorAll(".js-variant-select-input")
            ];
            inputWrappers.forEach((option, index)=>{
                if (index === 0) return;
                const optionInputs = [
                    ...option.querySelectorAll('input[type="radio"]:not(.disabled):checked')
                ];
                if (optionInputs.length == 0) {
                    const optionInputsEnable = [
                        ...option.querySelectorAll('input[type="radio"]:not(.disabled)')
                    ];
                    if (optionInputsEnable.length > 0) {
                        optionInputsEnable[0].checked = true;
                        optionInputsEnable[0].dispatchEvent(new Event("change", {
                            bubbles: true
                        }));
                    }
                }
            });
        }
        updateOptions() {
            this.options = Array.from(this.querySelectorAll("select"), (select)=>select.value);
        }
        constructor(){
            super();
            this.addEventListener("change", this.onVariantChange);
            this.from = this.closest("form");
            this.querySelectorAll(".js-variant-select").forEach((el)=>{
                if (el.selectedIndex == -1) el.value = el.querySelector("option:first-child").value;
                if (el.querySelectorAll("option:not(.is-disabled)").length > 1) ;
                else el.classList.add("has-one-option");
            });
        }
    }
    customElements.define("variant-selects", VariantSelect);
}


if (!customElements.get("product-form")) {
    class ProductForm extends HTMLElement {
        onSubmitHandler(evt) {
            evt.preventDefault();
            if (this.submitButton.getAttribute("aria-disabled") === "true") return;
            this.handleErrorMessage();
            this.submitButton.setAttribute("aria-disabled", true);
            this.submitButton.classList.add("loading");
            const config = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": `application/javascript`
                }
            };
            config.headers["X-Requested-With"] = "XMLHttpRequest";
            delete config.headers["Content-Type"];
            const formData = new FormData(this.form);
            config.body = formData;
            fetch(`${theme.routes.cart_add_url}`, config).then((response)=>response.json()).then((response)=>{
                if (response.status) this.handleErrorMessage(response.description);
                else window.LSG_OPEN_CART();
            }).catch((e)=>{
                console.error(e);
            }).finally(()=>{
                this.submitButton.classList.remove("loading");
                if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            });
        }
        handleErrorMessage(errorMessage = false) {
            this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
            if (!this.errorMessageWrapper) return;
            this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message");
            this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);
            if (errorMessage) this.errorMessage.textContent = errorMessage;
        }
        constructor(){
            super();
            this.form = this.querySelector("form");
            if (this.form) {
                this.form.querySelector("[name=id]").disabled = false;
                this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
            }
            this.submitButton = this.querySelector('[type="submit"]');
        }
    }
    customElements.define("product-form", ProductForm);
}


class $8bf5ee8a61fc26bc$var$LsgUpsellProducts extends HTMLElement {
    connectedCallback() {
        this.slider = this.querySelector(`.${this.classes.slider}`);
        this.initSlider();
        this.setupRecommendations();
    }
    initSlider() {
        if (!this.slider) return;
        const $slider = $(this.querySelector(`.${this.classes.slider}`));
        if (!$slider.length) return;
        const $arrowPrev = $(this.querySelector(`.${this.classes.sliderArrowPrev}`));
        const $arrowNext = $(this.querySelector(`.${this.classes.sliderArrowNext}`));
        $slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: $arrowPrev,
            nextArrow: $arrowNext
        });
    }
    setupRecommendations() {
        const handleIntersection = (entries, observer)=>{
            if (!entries[0].isIntersecting) return;
            observer.unobserve(this);
            const url = this.dataset.url;
            fetch(url).then((response)=>response.text()).then((text)=>{
                const html = document.createElement("div");
                html.innerHTML = text;
                const recommendations = html.querySelector(".lsg-upsell-products");
                if (recommendations && recommendations.innerHTML.trim().length) {
                    this.innerHTML = recommendations.innerHTML;
                    // Reinitialize the slider after replacing the content
                    this.slider = this.querySelector(`.${this.classes.slider}`);
                    this.initSlider();
                }
            }).catch((e)=>console.error("Error fetching recommendations:", e));
        };
        const observer = new IntersectionObserver(handleIntersection, {
            rootMargin: "0px 0px 200px 0px"
        });
        observer.observe(this);
    }
    constructor(){
        super();
        this.classes = {
            slider: "js-lsg-upsell-products-slider",
            sliderArrowPrev: "js-lsg-upsell-products-slider-arrow-prev",
            sliderArrowNext: "js-lsg-upsell-products-slider-arrow-next"
        };
    }
}
const $8bf5ee8a61fc26bc$var$customElementName = "lsg-upsell-products";
if (!customElements.get($8bf5ee8a61fc26bc$var$customElementName)) window.customElements.define($8bf5ee8a61fc26bc$var$customElementName, $8bf5ee8a61fc26bc$var$LsgUpsellProducts);


class $4611caf59d79de63$var$SingleAccordion {
    init() {
        this.question.addEventListener("click", ()=>{
            const isActive = this.accordion.classList.contains(this.activeClass);
            this.answer.style.maxHeight = isActive ? 0 : `${this.answer.scrollHeight + 20}px`;
            this.accordion.classList.toggle(this.activeClass);
        });
    }
    constructor(element){
        this.accordion = element;
        this.question = element.querySelector(".js-accordion-question");
        this.answer = element.querySelector(".js-accordion-answer");
        this.activeClass = "active";
        if (this.question && this.answer) this.init();
    }
}
document.addEventListener("DOMContentLoaded", ()=>{
    const accordions = document.querySelectorAll(".lsg-accordion");
    accordions.forEach((accordion)=>new $4611caf59d79de63$var$SingleAccordion(accordion));
});


class $1c72c96949b75a2d$var$CollectionFilter extends HTMLElement {
    setResultsCount() {
        this.resultsCount.forEach((el)=>{
            el.textContent = this.querySelectorAll(".js-collection-filter-product:not(.is-hide)").length;
        });
    }
    checkParameter() {
        const urlParams = new URLSearchParams(window.location.search);
        const sortBy = urlParams.getAll("sort_by");
        const mainCollection = urlParams.getAll("main-collection");
        this.dataFilters = {
            sort: sortBy.length > 0 ? sortBy[0] : "",
            collection: mainCollection.length > 0 ? mainCollection[0] : "all"
        };
        if (this.dataFilters.sort != "") {
            const el = this.querySelector(`${this.selectors.sortByToggle}[data-value="${this.dataFilters.sort}"]`);
            if (el != null) this.sortEvent(el, false);
        }
        if (this.dataFilters.collection != "all") {
            const el = this.querySelector(`${this.selectors.navToggle}[data-collection="${this.dataFilters.collection}"]`);
            if (el != null) this.navEvent(el, true);
            const els = this.querySelectorAll(`.sr-collection-block`);
            els.forEach((item)=>{
                item.style.display = "none";
            });
        }
        this.classList.add("is-load");
    }
    setUrl() {
        let url = "?";
        if (this.dataFilters.collection !== "all") url += `${url == "?" ? "" : "&"}main-collection=${this.dataFilters.collection}`;
        if (this.dataFilters.sort != "") url += `${url == "?" ? "" : "&"}sort_by=${this.dataFilters.sort}`;
        if (history.pushState) {
            var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + url;
            window.history.pushState({
                path: newurl
            }, "", newurl);
        }
    }
    initData() {
        this.products.forEach((el)=>{
            this.data.push({
                productId: el.getAttribute("data-product"),
                element: el
            });
        });
        this.collections.forEach((collection)=>{
            let data = [];
            collection.querySelectorAll(this.selectors.products).forEach((el)=>{
                data.push({
                    element: el,
                    rate: parseFloat(el.getAttribute("data-rating")),
                    created: Number(new Date(el.getAttribute("data-created"))),
                    price: parseInt(el.getAttribute("data-price"), 10)
                });
            });
            this.dataCollections.push({
                collection: collection,
                products: data
            });
        });
    }
    sortProducts(sortValue) {
        this.dataCollections.forEach((colEl)=>{
            let newProducts = [
                ...colEl.products
            ];
            console.log(sortValue, newProducts);
            switch(sortValue){
                case "created-descending":
                    newProducts.sort((a, b)=>b.created > a.created ? 1 : -1);
                    break;
                case "created-ascending":
                    newProducts.sort((a, b)=>a.created > b.created ? 1 : -1);
                    break;
                case "price-ascending":
                    newProducts.sort((a, b)=>a.price > b.price ? 1 : -1);
                    break;
                case "price-descending":
                    newProducts.sort((a, b)=>b.price > a.price ? 1 : -1);
                    break;
                default:
            }
            let index = 0;
            newProducts.forEach((product)=>{
                if (!product.element.classList.contains("is-hide")) {
                    /*
                        Bad for keyboard users. Tabbing through elements relies 
                        on HTML structure order, so this causes it to jump all
                        over the page.
                    */ // product.element.style.order = `${(index > 4) ? (index + 1) : index}`;
                    // index += 1;
                    const listEl = document.querySelector(`.hp-products__grid`);
                    listEl.appendChild(product.element);
                }
            });
        });
    }
    toggleNoResult() {
        let hasProducts = false;
        this.collections.forEach((el)=>{
            if (el.classList.contains("is-active")) {
                if (el.querySelectorAll(`${this.selectors.products}:not(.is-hide)`).length > 0) hasProducts = true;
            }
        });
        if (hasProducts) this.noProducts.classList.remove("is-show");
        else this.noProducts.classList.add("is-show");
    }
    navEvent(el, isSetUrl) {
        const dataCollection = el.getAttribute("data-collection");
        if (dataCollection !== "all") {
            this.products.forEach((product)=>{
                if (product.getAttribute("data-collection").split(",").includes(dataCollection)) product.classList.remove("is-hide");
                else product.classList.add("is-hide");
            });
            const els = this.querySelectorAll(`.sr-collection-block`);
            els.forEach((item)=>{
                item.style.display = "none";
            });
        } else {
            this.products.forEach((product)=>{
                product.classList.remove("is-hide");
            });
            const els = this.querySelectorAll(`.sr-collection-block`);
            els.forEach((item)=>{
                item.style.display = "";
            });
        }
        this.navToggle.forEach((elToggle)=>{
            elToggle.classList.remove("is-active");
        });
        el.classList.add("is-active");
        this.dataFilters.collection = dataCollection;
        this.toggleNoResult();
        this.setResultsCount();
        if (isSetUrl) this.setUrl();
    }
    initNav() {
        this.navToggle.forEach((el)=>{
            el.addEventListener("click", (e)=>{
                e.preventDefault();
                this.navEvent(el, true);
            });
        });
        this.sortByToggle.forEach((el)=>{
            el.addEventListener("change", (e)=>{
                e.preventDefault();
                console.log("change", el.value);
                // if (!el.classList.contains('is-active')) {
                this.sortEvent(el, true);
            // }
            });
        });
    }
    sortEvent(el, isSetUrl) {
        const sortValue = el.value;
        this.sortProducts(sortValue);
        this.sortByTitle.classList.remove("is-open");
        this.dataFilters.sort = sortValue;
        if (isSetUrl == true) this.setUrl();
        this.setResultsCount();
    }
    getValue(arr1, arr2) {
        const arr2Set = new Set(arr2);
        return arr1.some((el)=>arr2Set.has(el));
    }
    filterProducts(isSetUrl) {
        let tagsUrl = "";
        const activeTags = this.querySelectorAll(".js-collection-filter-toggle.is-selected");
        this.products.forEach((el)=>{
            el.classList.add("is-hide");
            el.classList.add("is-fade");
        });
        let dataFilters = {
            filter1: [],
            filter2: [],
            filter3: []
        };
        this.filterLists.forEach((el)=>{
            const activeFilters = el.querySelectorAll(".js-collection-filter-toggle.is-selected");
            let values = [];
            let index = 0;
            if (activeFilters.length > 0) activeFilters.forEach((filter)=>{
                values.push(filter.getAttribute("data-filter"));
                index = filter.getAttribute("data-index");
            });
            const name = `filter${index}`;
            dataFilters[name] = values;
        });
        let filteredData = this.data;
        if (dataFilters.filter3.length > 0) filteredData = filteredData.filter((el)=>this.getValue(dataFilters.filter3, el.filter3));
        if (dataFilters.filter2.length > 0) filteredData = filteredData.filter((el)=>this.getValue(dataFilters.filter2, el.filter2));
        if (dataFilters.filter1.length > 0) filteredData = filteredData.filter((el)=>this.getValue(dataFilters.filter1, el.filter1));
        filteredData.forEach((el)=>{
            el.element.classList.remove("is-hide");
            setTimeout(()=>{
                el.element.classList.remove("is-fade");
            }, 1);
        });
        this.collections.forEach((el)=>{
            if (el.querySelectorAll(`${this.selectors.products}:not(.is-hide)`).length > 0) el.classList.add("has-products");
            else el.classList.remove("has-products");
        });
        const sortValue = this.querySelector(`${this.selectors.sortByToggle}.is-active`).getAttribute("data-value");
        this.sortProducts(sortValue);
        this.dataFilters.filter1 = dataFilters.filter1;
        this.dataFilters.filter2 = dataFilters.filter2;
        this.dataFilters.filter3 = dataFilters.filter3;
        if (isSetUrl == true) this.setUrl();
        else this.collectionsWrap.classList.add("is-show");
        this.toggleNoResult();
        this.setResultsCount();
    }
    setSellingPlan(productId, rtxWidgetInjectionParent, addToCart, el) {
        const productData = JSON.parse(document.getElementById(rtxWidgetInjectionParent.getAttribute("data-product-json")).innerHTML);
        const form = rtxWidgetInjectionParent.closest("form");
        const currentVariant = parseInt(form.querySelector("[name='id']").value, 10);
        const variant = productData.variants.find((o)=>o.id === currentVariant);
        var selectedOption = rtxWidgetInjectionParent.querySelector(`input[name="selling_plan_select"]:checked`);
        if (selectedOption.value === "onetime") {
            rtxWidgetInjectionParent.querySelector(`#selling_plan_${productId}`).value = "";
            rtxWidgetInjectionParent.querySelectorAll(`.rtx_option_plans`).forEach((plans)=>{
                plans.style.display = "none";
            });
        } else if (selectedOption.value === "subsave") {
            if (variant.avaliable) {
                var planId = form.querySelector(".rtx_option_plans_label.active");
                if (planId.length > 0) {
                    var id = parseInt(planId.attr("data-id"), 10);
                    const curSelPlan = variant.selling_plan_allocations.find((o)=>o.selling_plan_id === id);
                    if (curSelPlan) document.querySelector(`#rtx_widget_injection_parent_${productId} .rtx_option--sub .rtx_option_subheading`).textContent = theme.Currency.formatMoney(curSelPlan.price, theme.moneyFormat);
                }
            }
            if (rtxWidgetInjectionParent.querySelector(`input[name="rtx_option_plans_dropdown"]:checked`) == null) return false;
            rtxWidgetInjectionParent.querySelector(`[name="selling_plan"]`).value = rtxWidgetInjectionParent.querySelector(`input[name="rtx_option_plans_dropdown"]:checked`).value;
            rtxWidgetInjectionParent.querySelectorAll(`.rtx_option_plans`).forEach((plans)=>{
                plans.style.display = "grid";
            });
        }
    }
    constructor(){
        super();
        this.selectors = {
            collections: ".js-collection-filter-block",
            navToggle: ".js-collection-filter-nav-toggle",
            products: ".js-collection-filter-product",
            sortByToggle: ".js-collection-filter-sort-by-toggle",
            sortByTitle: ".js-collection-filter-sort-by-ttl",
            resultsCount: ".js-collection-filter-result-count",
            noProducts: ".js-collection-filter-no-products"
        };
        this.collections = this.querySelectorAll(this.selectors.collections);
        this.resultsCount = this.querySelectorAll(this.selectors.resultsCount);
        this.navToggle = this.querySelectorAll(this.selectors.navToggle);
        this.products = this.querySelectorAll(this.selectors.products);
        this.sortByToggle = this.querySelectorAll(this.selectors.sortByToggle);
        this.sortByTitle = this.querySelector(this.selectors.sortByTitle);
        this.noProducts = this.querySelector(this.selectors.noProducts);
        this.data = [];
        this.dataCollections = [];
        this.dataFilters = {
            sort: "",
            collection: "all"
        };
        this.isLoading = false;
        this.initData();
        this.initNav();
        this.setResultsCount();
        this.checkParameter();
    }
}
var $1c72c96949b75a2d$export$2e2bcd8739ae039 = $1c72c96949b75a2d$var$CollectionFilter;


function $880684a6432be47c$var$removeTrapFocus(elementToFocus = null) {
    document.removeEventListener("focusin", $880684a6432be47c$var$trapFocusHandlers.focusin);
    document.removeEventListener("focusout", $880684a6432be47c$var$trapFocusHandlers.focusout);
    document.removeEventListener("keydown", $880684a6432be47c$var$trapFocusHandlers.keydown);
    if (elementToFocus) elementToFocus.focus();
}
const $880684a6432be47c$var$trapFocusHandlers = {};
function $880684a6432be47c$var$getFocusableElements(container) {
    return Array.from(container.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
}
function $880684a6432be47c$var$trapFocus(container, elementToFocus = container) {
    var elements = $880684a6432be47c$var$getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];
    $880684a6432be47c$var$removeTrapFocus();
    $880684a6432be47c$var$trapFocusHandlers.focusin = (event)=>{
        if (event.target !== container && event.target !== last && event.target !== first) return;
        document.addEventListener("keydown", $880684a6432be47c$var$trapFocusHandlers.keydown);
    };
    $880684a6432be47c$var$trapFocusHandlers.focusout = function() {
        document.removeEventListener("keydown", $880684a6432be47c$var$trapFocusHandlers.keydown);
    };
    $880684a6432be47c$var$trapFocusHandlers.keydown = function(event) {
        if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
        // On the last focusable element and tab forward, focus the first element.
        if (event.target === last && !event.shiftKey) {
            event.preventDefault();
            first.focus();
        }
        //  On the first focusable element and tab backward, focus the last element.
        if ((event.target === container || event.target === first) && event.shiftKey) {
            event.preventDefault();
            last.focus();
        }
    };
    document.addEventListener("focusout", $880684a6432be47c$var$trapFocusHandlers.focusout);
    document.addEventListener("focusin", $880684a6432be47c$var$trapFocusHandlers.focusin);
    elementToFocus.focus();
    if (elementToFocus.tagName === "INPUT" && [
        "search",
        "text",
        "email",
        "url"
    ].includes(elementToFocus.type) && elementToFocus.value) elementToFocus.setSelectionRange(0, elementToFocus.value.length);
}
class $880684a6432be47c$var$DetailsModal extends HTMLElement {
    isOpen() {
        return this.detailsContainer.hasAttribute("open");
    }
    onSummaryClick(event) {
        event.preventDefault();
        event.target.closest("details").hasAttribute("open") ? this.close() : this.open(event);
    }
    onBodyClick(event) {
        if (!this.contains(event.target) || event.target.classList.contains("modal-overlay")) this.close(false);
    }
    open(event) {
        this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
        event.target.closest("details").setAttribute("open", true);
        document.body.addEventListener("click", this.onBodyClickEvent);
        document.body.classList.add("overflow-hidden");
        $880684a6432be47c$var$trapFocus(this.detailsContainer.querySelector('[tabindex="-1"]'), this.detailsContainer.querySelector('input:not([type="hidden"])'));
    }
    close(focusToggle = true) {
        $880684a6432be47c$var$removeTrapFocus(focusToggle ? this.summaryToggle : null);
        this.detailsContainer.removeAttribute("open");
        document.body.removeEventListener("click", this.onBodyClickEvent);
        document.body.classList.remove("overflow-hidden");
    }
    constructor(){
        super();
        this.detailsContainer = this.querySelector("details");
        this.summaryToggle = this.querySelector("summary");
        this.detailsContainer.addEventListener("keyup", (event)=>event.code.toUpperCase() === "ESCAPE" && this.close());
        this.summaryToggle.addEventListener("click", this.onSummaryClick.bind(this));
        this.querySelectorAll(".js-search-modal-close").forEach((el)=>{
            el.addEventListener("click", this.close.bind(this));
        });
        this.summaryToggle.setAttribute("role", "button");
    }
}
var $880684a6432be47c$export$2e2bcd8739ae039 = $880684a6432be47c$var$DetailsModal;


function $08802e6d64989513$var$debounce(fn, wait) {
    let t;
    return (...args)=>{
        clearTimeout(t);
        t = setTimeout(()=>fn.apply(this, args), wait);
    };
}
class $08802e6d64989513$var$PredictiveSearch extends HTMLElement {
    toggleResetButton() {
    // const resetIsHidden = this.resetButton.classList.contains('hidden');
    // if (this.input.value.length > 0 && resetIsHidden) {
    //   this.resetButton.classList.remove('hidden');
    // } else if (this.input.value.length === 0 && !resetIsHidden) {
    //   this.resetButton.classList.add('hidden');
    // }
    }
    shouldResetForm() {
        return !document.querySelector('[aria-selected="true"] a');
    }
    setupEventListeners() {
        this.input.form.addEventListener("submit", this.onFormSubmit.bind(this));
        this.input.addEventListener("focus", this.onFocus.bind(this));
        this.addEventListener("focusout", this.onFocusOut.bind(this));
        this.addEventListener("keyup", this.onKeyup.bind(this));
        this.addEventListener("keydown", this.onKeydown.bind(this));
    }
    getQuery() {
        return this.input.value.trim();
    }
    onChange() {
        var // Remove the results when they are no longer relevant for the new search term
        // so they don't show up when the dropdown opens again
        _this_querySelector;
        this.toggleResetButton();
        const newSearchTerm = this.getQuery();
        if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) (_this_querySelector = this.querySelector("#predictive-search-results-groups-wrapper")) === null || _this_querySelector === void 0 ? void 0 : _this_querySelector.remove();
        // Update the term asap, don't wait for the predictive search query to finish loading
        this.updateSearchForTerm(this.searchTerm, newSearchTerm);
        this.searchTerm = newSearchTerm;
        if (!this.searchTerm.length) {
            this.close(true);
            return;
        }
        this.getSearchResults(this.searchTerm);
    }
    onFormSubmit(event) {
        if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
    }
    onFormReset(event) {
        // Prevent default so the form reset doesn't set the value gotten from the url on page load
        event.preventDefault();
        // Don't reset if the user has selected an element on the predictive search dropdown
        if (this.shouldResetForm()) {
            this.input.value = "";
            this.input.focus();
            this.toggleResetButton();
        }
        if (this.shouldResetForm()) {
            this.searchTerm = "";
            this.abortController.abort();
            this.abortController = new AbortController();
            this.closeResults(true);
        }
    }
    onFocus() {
        console.log("focus");
        const currentSearchTerm = this.getQuery();
        if (!currentSearchTerm.length) return;
        if (this.searchTerm !== currentSearchTerm) // Search term was changed from other search input, treat it as a user change
        this.onChange();
        else if (this.getAttribute("results") === "true") this.open();
        else this.getSearchResults(this.searchTerm);
    }
    onFocusOut() {
        setTimeout(()=>{
            if (!this.contains(document.activeElement)) this.close();
        });
    }
    onKeyup(event) {
        if (!this.getQuery().length) this.close(true);
        event.preventDefault();
        switch(event.code){
            case "ArrowUp":
                this.switchOption("up");
                break;
            case "ArrowDown":
                this.switchOption("down");
                break;
            case "Enter":
                this.selectOption();
                break;
        }
    }
    onKeydown(event) {
        // Prevent the cursor from moving in the input when using the up and down arrow keys
        if (event.code === "ArrowUp" || event.code === "ArrowDown") event.preventDefault();
    }
    updateSearchForTerm(previousTerm, newTerm) {
        const searchForTextElement = this.querySelector("[data-predictive-search-search-for-text]");
        const currentButtonText = searchForTextElement === null || searchForTextElement === void 0 ? void 0 : searchForTextElement.innerText;
        if (currentButtonText) {
            if (currentButtonText.match(new RegExp(previousTerm, "g")).length > 1) // The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
            return;
            const newButtonText = currentButtonText.replace(previousTerm, newTerm);
            searchForTextElement.innerText = newButtonText;
        }
    }
    switchOption(direction) {
        if (!this.getAttribute("open")) return;
        const moveUp = direction === "up";
        const selectedElement = this.querySelector('[aria-selected="true"]');
        // Filter out hidden elements (duplicated page and article resources) thanks
        // to this https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent
        const allVisibleElements = Array.from(this.querySelectorAll("li, button.predictive-search__item")).filter((element)=>element.offsetParent !== null);
        let activeElementIndex = 0;
        if (moveUp && !selectedElement) return;
        let selectedElementIndex = -1;
        let i = 0;
        while(selectedElementIndex === -1 && i <= allVisibleElements.length){
            if (allVisibleElements[i] === selectedElement) selectedElementIndex = i;
            i++;
        }
        this.statusElement.textContent = "";
        if (!moveUp && selectedElement) activeElementIndex = selectedElementIndex === allVisibleElements.length - 1 ? 0 : selectedElementIndex + 1;
        else if (moveUp) activeElementIndex = selectedElementIndex === 0 ? allVisibleElements.length - 1 : selectedElementIndex - 1;
        if (activeElementIndex === selectedElementIndex) return;
        const activeElement = allVisibleElements[activeElementIndex];
        activeElement.setAttribute("aria-selected", true);
        if (selectedElement) selectedElement.setAttribute("aria-selected", false);
        this.input.setAttribute("aria-activedescendant", activeElement.id);
    }
    selectOption() {
        const selectedOption = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');
        if (selectedOption) selectedOption.click();
    }
    getSearchResults(searchTerm) {
        const queryKey = searchTerm.replace(" ", "-").toLowerCase();
        this.setLiveRegionLoadingState();
        if (this.cachedResults[queryKey]) {
            this.renderSearchResults(this.cachedResults[queryKey]);
            return;
        }
        fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search&resources[options][fields]=author,body,product_type,tag,title,variants.barcode,variants.sku,variants.title,vendor`, {
            signal: this.abortController.signal
        }).then((response)=>{
            if (!response.ok) {
                var error = new Error(response.status);
                this.close();
                throw error;
            }
            return response.text();
        }).then((text)=>{
            const resultsMarkup = new DOMParser().parseFromString(text, "text/html").querySelector("#shopify-section-predictive-search").innerHTML;
            // Save bandwidth keeping the cache in all instances synced
            this.allPredictiveSearchInstances.forEach((predictiveSearchInstance)=>{
                predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
            });
            this.renderSearchResults(resultsMarkup);
        }).catch((error)=>{
            if ((error === null || error === void 0 ? void 0 : error.code) === 20) // Code 20 means the call was aborted
            return;
            this.close();
            throw error;
        });
    }
    setLiveRegionLoadingState() {
        this.statusElement = this.statusElement || this.querySelector(".predictive-search-status");
        this.loadingText = this.loadingText || this.getAttribute("data-loading-text");
        this.setLiveRegionText(this.loadingText);
        this.setAttribute("loading", true);
    }
    setLiveRegionText(statusText) {
        this.statusElement.setAttribute("aria-hidden", "false");
        this.statusElement.textContent = statusText;
        setTimeout(()=>{
            this.statusElement.setAttribute("aria-hidden", "true");
        }, 1000);
    }
    renderSearchResults(resultsMarkup) {
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.setAttribute("results", true);
        this.setLiveRegionResults();
        this.open();
    }
    setLiveRegionResults() {
        this.removeAttribute("loading");
        this.setLiveRegionText(this.querySelector("[data-predictive-search-live-region-count-value]").textContent);
    }
    getResultsMaxHeight() {
        this.resultsMaxHeight = window.innerHeight - document.querySelector("#shopify-section-header").getBoundingClientRect().bottom + 20;
        return this.resultsMaxHeight;
    }
    open() {
        this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
        this.setAttribute("open", true);
        this.input.setAttribute("aria-expanded", true);
        this.isOpen = true;
    }
    close(clearSearchTerm = false) {
        this.closeResults(clearSearchTerm);
        this.isOpen = false;
    }
    closeResults(clearSearchTerm = false) {
        if (clearSearchTerm) {
            this.input.value = "";
            this.removeAttribute("results");
        }
        console.log(this);
        const selected = this.querySelector('[aria-selected="true"]');
        if (selected) selected.setAttribute("aria-selected", false);
        this.input.setAttribute("aria-activedescendant", "");
        this.removeAttribute("loading");
        this.removeAttribute("open");
        this.input.setAttribute("aria-expanded", false);
        this.resultsMaxHeight = false;
        this.predictiveSearchResults.removeAttribute("style");
    }
    constructor(){
        super();
        this.input = this.querySelector('input[type="search"]');
        this.resetButton = this.querySelector('button[type="reset"]');
        if (this.input) {
            this.input.form.addEventListener("reset", this.onFormReset.bind(this));
            this.input.addEventListener("input", $08802e6d64989513$var$debounce((event)=>{
                this.onChange(event);
            }, 300).bind(this));
        }
        this.cachedResults = {};
        this.predictiveSearchResults = this.querySelector("[data-predictive-search]");
        this.allPredictiveSearchInstances = document.querySelectorAll("predictive-search");
        this.isOpen = false;
        this.abortController = new AbortController();
        this.searchTerm = "";
        this.setupEventListeners();
    }
}
var $08802e6d64989513$export$2e2bcd8739ae039 = $08802e6d64989513$var$PredictiveSearch;


$(function() {
    (0, $39a084f5d3bd059b$export$2e2bcd8739ae039).init();
    (0, $860f3363aeb1bd10$export$2e2bcd8739ae039).init();
    (0, $b83f6da647d0524b$export$2e2bcd8739ae039).init();
    (0, $84b968c03f5ed141$export$2e2bcd8739ae039).init();
    (0, $fbe1969b43572293$export$2e2bcd8739ae039).init();
    (0, $13c07fe2ad43ba53$export$2e2bcd8739ae039).init();
    // sidecart.init();
    // slidecart.init();
    (0, $fa4f3fae4ae078f8$export$2e2bcd8739ae039).init();
    (0, $ee62d4dfdd7d940f$export$2e2bcd8739ae039).init();
    if ($("body.suffix-seedlings")[0]) {
        (0, $4b080af75b914be2$export$2e2bcd8739ae039).init();
        (0, $b88d8452506c9393$export$2e2bcd8739ae039).init();
        (0, $1eb0adad1e3be584$export$2e2bcd8739ae039).init();
        (0, $35f8fb112b56de8b$export$2e2bcd8739ae039).init();
    }
    if ($("body.suffix-black-history-month")[0]) (0, $b88d8452506c9393$export$2e2bcd8739ae039).init();
    if ($("body.template-index")[0]) (0, $b88d8452506c9393$export$2e2bcd8739ae039).init();
    if ($("body.suffix-careers-lp")[0]) {
        (0, $df45f0987d6f0645$export$2e2bcd8739ae039).init();
        (0, $28a65792f86eb58e$export$2e2bcd8739ae039).init();
        (0, $e58b8765f7866f3c$export$2e2bcd8739ae039).init();
        (0, $594a965aa5e33f8e$export$2e2bcd8739ae039).init();
        (0, $c3958bd31d4ac42c$export$2e2bcd8739ae039).init();
    }
    if ($("body.suffix-hangover-bundle")[0]) (0, $bdd457042d4c0801$export$2e2bcd8739ae039).init();
    if ($("body.template-customers-login")[0]) (0, $591a3d5b84cfbab7$export$2e2bcd8739ae039).init();
    // Hanldes the Convert A/B Subscription Quiz
    if ($("body.suffix-hangover-subscription.convert-hangover-subscription-quiz")[0]) (0, $fabcb6bca031c168$export$2e2bcd8739ae039).init();
    if ($("body.template-product")[0] || $("body.suffix-subscribe")[0]) {
        (0, $d813ad76ebd8a390$export$2e2bcd8739ae039).init();
        (0, $b234e7910ceea1c2$export$2e2bcd8739ae039).init();
    }
    if ($("body.suffix-our-story")[0]) (0, $ef49bc2968620044$export$2e2bcd8739ae039).init();
    if ($("body.suffix-rewards")[0]) (0, $c9ba80c1cd826078$export$2e2bcd8739ae039).init();
    if ($("body.suffix-world-coconut-day-lp")[0]) (0, $e8b8aafa70436427$export$2e2bcd8739ae039).init();
    customElements.define("roblox-products", (0, $89bb14a391f35b87$export$2e2bcd8739ae039));
    document.querySelectorAll(".js-back-btn").forEach((el)=>{
        el.addEventListener("click", (e)=>{
            e.preventDefault();
            if (document.referrer != "") window.location = document.referrer;
            else window.location = "/";
        });
    });
    const carouselReviewsItems = document.querySelectorAll(".reviews__item-holder");
    carouselReviewsItems.forEach((el)=>{
        // translate(${el.getAttribute('data-xStart')}%, ${el.getAttribute('data-yStart')}%)
        el.style.transform = `rotate(${el.getAttribute("data-rotateStart")}deg)`;
    });
    if (!customElements.get("collection-filter")) customElements.define("collection-filter", (0, $1c72c96949b75a2d$export$2e2bcd8739ae039));
    customElements.define("details-modal", (0, $880684a6432be47c$export$2e2bcd8739ae039));
    customElements.define("predictive-search", (0, $08802e6d64989513$export$2e2bcd8739ae039));
});
if (!customElements.get("multimedia-block")) customElements.define("multimedia-block", (0, $64fb530211c04ea0$export$2e2bcd8739ae039));
if (!customElements.get("multimedia-search")) customElements.define("multimedia-search", (0, $27664f6f0419e892$export$2e2bcd8739ae039));

})();
//# sourceMappingURL=index.js.map
